/*
layers to be presented in the project detail page sidebar
for now i only added norwegian sources, as didn not research enough in other countries.
*/
const infoLayers = {
	"Latvia": [
		{
			name: "Cadastral",
			icon: "ri-octagon-line",
			defaultOpen:false,
			layers: [
				{
					id: "cadastral-lv",
					name: "Cadastral units",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/cadastral.1/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'cadastral-lv-layer',
						'type': 'line',
						'source': 'cadastral-lv',
						'source-layer': 'cadastral.1',
						'layout': {
						
						},
						'paint': {
							'line-color': '#BF69A2',
							'line-width': 1
						}
					}
				},
				{
					id: "cadastral-lv-label",
					name: "Cadastral units labels",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/cadastral.1/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'cadastral-lv-label-layer',
						'type': 'symbol',
						'source': 'cadastral-lv-label',
						'source-layer': 'cadastral.1',
						'layout': {
						
						},
						paint: {
						    "text-color": "#BF69A2"
						  },
						'layout': {
							'text-field': ['get', 'code'],
							
							'text-justify': 'auto',
							'text-size': 12
						}
					}
				},
				{
					id: "cadastral-all",
					name: "Properties with owners",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/landowners_lv,cadastral.1/{z}/{x}/{y}"]
					},
					layer:[
						{
							'id': 'cadastral-unknown-fill',
							'type': 'fill',
							'source': 'cadastral-all',
							'source-layer': 'cadastral.1',
							'paint': {
								'fill-color': ['case', ['in', ['get', 'vindrid'], ["literal", []]], "#e5e9f1", '#ffffff'],
								'fill-opacity': ['case', ['in', ['get', 'vindrid'], ["literal", []]], 1, 0]
							}
						},
						{
							'id': 'cadastral-known-fill',
							'type': 'fill',
							'source': 'cadastral-all',
							'source-layer': 'landowners_lv',
							'paint': {
								'fill-color': [
							        'case',                             // Start a conditional expression
							        ['has', 'color'],                   // Check if the 'color' property exists
							        ['get', 'color'],                   // If true, use the color from the data
							        '#FFFFFF'                           // Otherwise, use white color
							    ],
								'fill-opacity': 1
							}
						},
						{
							'id': 'cadastral-unknown-fill-line',
							'type': 'line',
							'source': 'cadastral-all',
							'source-layer': 'cadastral.1',
							'paint': {
								'line-color': '#3477eb',
								'line-width': 1
							},
						},
						{
							'id': 'cadastral-unknown-fill-label',
							'type': 'symbol',
							'source': 'cadastral-all',
							'source-layer': 'cadastral.1',
							"layout": {
							    "text-field": ["get", "vindrid"], // Assuming 'name' is the property you want to label with
							    "text-allow-overlap": false,
							    "text-padding": 10,
							    "text-size": [
							      "interpolate",
							      ["linear"],
							      ["zoom"],
							      12, 11, 
							      15, 16  
							    ],
							    "text-max-width": 8,
							    "text-anchor": "center",
							    "text-offset": [0, 0],
							    "text-optional": true,
							    "text-variable-anchor": ["center", "top", "bottom", "left", "right"]
							  },
							  "paint": {
							    "text-color": "#3477eb"
							  },
							  "filter": ["==", "$type", "Polygon"]
						}
					]
				}
			]
		},
		{
			name: "Restrictions",
			icon: "ri-indeterminate-circle-line",
			layers: [

				{
					id: "lv-buffered-border",
					name: "Buffered border Latvia",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/lv_border_latvia_buffer/{z}/{x}/{y}"]
					},
					layer:[
						{
							'id': 'lv-buffered-border-layer',
							'type': 'fill',
							'source': 'lv-buffered-border',
							'source-layer': 'lv_border_latvia_buffer',
							'paint': {
								'fill-color': '#000000',
								'fill-opacity': 0.7
							}
						}
					]
				},
				{
					id: "lv-state-roads-buffered",
					name: "State roads buffered 300m",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/lv_state_roads_buffered_300m/{z}/{x}/{y}"]
					},
					layer:[
						{
							'id': 'lv-state-roads-buffered-layer',
							'type': 'fill',
							'source': 'lv-state-roads-buffered',
							'source-layer': 'lv_state_roads_buffered_300m',
							'paint': {
								'fill-color': '#000000',
								'fill-opacity': 0.6
							}
						}
					]
				},
				{
					id: "lv-communal-buffered",
					name: "Municipality roads buffered 100m",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/lv_communal_buffered_100m/{z}/{x}/{y}"]
					},
					layer:[
						{
							'id': 'lv-communal-buffered-layer',
							'type': 'fill',
							'source': 'lv-communal-buffered',
							'source-layer': 'lv_communal_buffered_100m',
							'paint': {
								'fill-color': '#000000',
								'fill-opacity': 0.6
							}
						}
					]
				},
				{
					id: "buildings-buffered-800m-lv",
					name: "Houses buffered 800m",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.latvia_buildings_800m-tiles'
					},
					layer:{
						'id': 'buildings-buffered-800m-lv-layer',
						'type': 'fill',
						'source': 'buildings-buffered-800m-lv',
						'source-layer': 'latvia_buildings_800m-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#9EAAB0',
						}
					}
				},
				{
					id: "lv-power-lines-buffer-40-source",
					name: "Power lines buffer 40m",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/fmfdygwahynzpmorbcjf/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'lv-power-lines-buffer-40-layer',
						'type': 'fill',
						'source': 'lv-power-lines-buffer-40-source',
						'source-layer': 'fmfdygwahynzpmorbcjf',
						'layout': {
						
						},
						'paint': {
							'fill-color': "#000000",
							'fill-opacity': 0.8
						}
					}
				},
				{
					id: "lv-power-lines-buffer-280-source",
					name: "Power lines buffer 280m",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/rzqowzrgyqzpuvsyzfuy/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'lv-power-lines-buffer-280-layer',
						'type': 'fill',
						'source': 'lv-power-lines-buffer-280-source',
						'source-layer': 'rzqowzrgyqzpuvsyzfuy',
						'layout': {
						
						},
						'paint': {
							'fill-color': "#000000",
							'fill-opacity': 0.8
						}
					}
				},
			]
		},	
		{
			name: "Infrastructure",
			icon: "ri-signal-tower-line",
			layers: [
				{
					id: "grid-lv",
					name: "Power lines",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.latvia-grid-tiles'
					},
					layer:{
						'id': 'grid-lv-layer',
						'type': 'line',
						'source': 'grid-lv',
						'source-layer': 'latvia_grid',
						'layout': {
						
						},
						'paint': {
							'line-color': [
								'case',
								['==', ['get', 'voltage'], '330000'],
								'#60759F',
								['==', ['get', 'voltage'], '110000'],
								'#60759F',
								['==', ['get', 'voltage'], '330000;110000'],
								'#377CA4',
								'#889ADD'
							],
							'line-opacity': [
								'case',
								['==', ['get', 'voltage'], '330000'],
								1,
								['==', ['get', 'voltage'], '110000'],
								1,
								['==', ['get', 'voltage'], '330000;110000'],
								1,
								0
							],
							'line-width': 3
						}
					}
				},

				{
					id: "grid-lv-label",
					name: "Power lines label",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.latvia-grid-tiles'
					},
					layer:{
						'id': 'grid-lv-label-layer',
						'type': 'symbol',
						'source': 'grid-lv-label',
						'source-layer': 'latvia_grid',
						'layout': {
							'text-field': [
								'case',
								['==', ['get', 'voltage'], '330000'],
								'330kV',
								['==', ['get', 'voltage'], '110000'],
								'100kV',
								['==', ['get', 'voltage'], '330000;110000'],
								'110/330kV',
								''
							],
							'symbol-placement': 'line',
							'text-variable-anchor': ['top'],
							'text-radial-offset': 10.5,
							'text-justify': 'auto',
							'text-size': 16,
							
						},
						'paint': {
							'text-halo-width': 2,
							'text-halo-color': "rgba(255,255,255, 0.75)"
						}
					}
				},
				{
					id: "buildings-lv",
					name: "Houses",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.latvia-buildings-tiles'
					},
					layer:{
						'id': 'buildings-lv-layer',
						'type': 'fill',
						'source': 'buildings-lv',
						'source-layer': 'latvia_buildings',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#889ADD',
						}
					}
				},
				
				{
					id: "railways-lv",
					name: "Railways",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.latvia-railway-tiles'
					},
					layer:{
						'id': 'railways-lv-layer',
						'type': 'fill',
						'source': 'railways-lv',
						'source-layer': 'latvia-railway',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#9EAAB0',
						}
					}
				},
				{
					id: "lv-state-roads",
					name: "State roads",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/lv_state_roads/{z}/{x}/{y}"]
					},
					layer:[
						{
							'id': 'lv-state-roads-layer',
							'type': 'line',
							'source': 'lv-state-roads',
							'source-layer': 'lv_state_roads',
							'paint': {
								'line-color': '#000000',
								'line-width': 3
							}
						}
					]
				},
				
			]
		},
		{
			name: "Nature",
			icon: "ri-tree-line",
			defaultOpen:false,
			layers: [
				{
					id: "forest-lv",
					name: "Forest",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.latvia-forest-tiles'
					},
					layer:{
						'id': 'forest-lv-layer',
						'type': 'fill',
						'source': 'forest-lv',
						'source-layer': 'latvia_forest',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#228B22',
							'fill-opacity': 0.9
						}
					}
				},
				{
					id: "nature-reserves-lv",
					name: "Nature Reserves",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.latvia-nature-reserves-tiles'
					},
					layer:{
						'id': 'nature-reserves-lv-layer',
						'type': 'fill',
						'source': 'nature-reserves-lv',
						'source-layer': 'latvia_nature_reserves',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#4E8BD4',
							'fill-opacity': 0.8
						}
					}
				},
				
				{
					id: "natura-2000-source",
					name: "Natura 2000",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.natura-2000-tiles'
					},
					layer:{
						'id': 'natura-2000-source-layer',
						'type': 'fill',
						'source': 'natura-2000-source',
						'source-layer': 'natura-2000-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#8fce00'
						}
					}
				},
				{
					id: "lv-natura2000-buffer-source",
					name: "Natura 2000 buffer",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.lv-natura2000-buffer-tiles'
					},
					layer:{
						'id': 'lv-natura2000-buffer-source-layer',
						'type': 'fill',
						'source': 'lv-natura2000-buffer-source',
						'source-layer': 'lv-natura2000-buffer-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#50957F'
						}
					}
				}
			]
		},
		{
			name: "Wind",
			icon: "ri-windy-line",
			layers: [
				{
					id: "wind-lv-raster",
					name: "Wind map (100m)",
					defaultChecked: false,
					source : {
						type: 'raster',
						'tiles': [ 
							'https://vindrtech.com/mapproxy/service?layer=wind_map&style=&tilematrixset=webmercator&Service=WMTS&Request=GetTile&Version=1.0.0&Format=png&TileMatrix={z}&TileCol={x}&TileRow={y}'
						],
						tileSize: 256
					},
					layer:{
						id: "wind-lv-raster-layer",
						type: "raster",
						source: "wind-lv-raster",
						paint: {}
					},
					legend:'https://siteplanner.blob.core.windows.net/uploadimages/wind_legend.png'
				},
				{
					id: "wind-lv-150m",
					name: "Wind data (150m)",
					defaultChecked: false,
					source : {
						type: 'raster',
						'tiles': [ 
							'https://vindrtech.com/mapproxy/service?layer=wind_map_150m&style=&tilematrixset=webmercator&Service=WMTS&Request=GetTile&Version=1.0.0&Format=png&TileMatrix={z}&TileCol={x}&TileRow={y}'
						],
						tileSize: 256
					},
					layer:{
						id: "wind-lv-150m-layer",
						type: "raster",
						source: "wind-lv-150m",
						paint: {}
					},
					legend:'https://siteplanner.blob.core.windows.net/uploadimages/wind_legend.png'
				},
				{
					id: "wind-lv",
					name: "Wind map (vector 100m)",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.latvia-wind-gridded-tiles'
					},
					layer:{
						'id': 'wind-lv-layer',
						'type': 'fill',
						'source': 'wind-lv',
						'source-layer': 'latvia_wind_gridded',
						'layout': {
						
						},
						'layout': {
						},
						'paint': {
							'fill-color': [
							  "interpolate",
							  ["linear"],
							  ['get', '_mean'],
							  6.4,
							  "#ffffff",
							  6.5,
							  "#ffefef",
							  6.6,
							  "#ffdfdf",
							  6.7,
							  "#ffcfcf",
							  6.8,
							  "#ffbfbf",
							  6.9,
							  "#ffafaf",
							  7,
							  "#ff9f9f",
							  7.1,
							  "#ff8f8f",
							  7.2,
							  "#ff8080",
							  7.3,
							  "#ff7070",
							  7.4,
							  "#ff6060",
							  7.5,
							  "#ff5050",
							  7.6,
							  "#ff4040",
							  7.7,
							  "#ff3030",
							  7.8,
							  "#ff2020",
							  7.9,
							  "#ff1010",
							  8,
							  "#ff0000"
							],
							'fill-opacity': [
								'case',
								['<', ['get', '_mean'], 6.5],
								0,
								['<', ['get', '_count'], 0],
								0,
								1
							]
						}
					},
					legend:'https://siteplanner.blob.core.windows.net/uploadimages/wind_legend.png'
				}
			]
		},
		{
			name: "Administrative boundaries",
			icon: "ri-community-line",
			layers: [
				{
					id: "municipality-borders-lv",
					name: "Municipality borders",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.latvia-municipalities-tiles'
					},
					layer:{
						'id': 'municipality-borders-lv-layer',
						'type': 'line',
						'source': 'municipality-borders-lv',
						'source-layer': 'latvia_municipalities',
						'layout': {
						
						},
						'paint': {
							'line-color': '#000000',
							'line-width': 2,
							'line-opacity': 0.9
						}
					}
				},
				{
					id: "municipality-borders-label-lv",
					name: "Municipality labels",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.latvia-municipalities-tiles'
					},
					layer:{
						'id': 'municipality-borders-label-lv-layer',
						'type': 'symbol',
						'source': 'municipality-borders-label-lv',
						'source-layer': 'latvia_municipalities',
						'layout': {
							'text-field': ['get', 'LABEL'],
							'text-variable-anchor': ['center'],
							'text-justify': 'auto',
							'text-size': 24
						},
						'paint': {
							
						}
					}
				},
			]
		},
		{
			name: "Nicgale",
			layers: [
				{
					id: "lv-nicgale-biotopi-source",
					name: "biotopi",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/mmdfppojwhnafgtevsyr/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'lv-nicgale-biotopi-layer',
						'type': 'fill',
						'source': 'lv-nicgale-biotopi-source',
						'source-layer': 'mmdfppojwhnafgtevsyr',
						'layout': {
						
						},
						'paint': {
							'fill-opacity': 0.6,
							'fill-color': "#000000"
						}
					}
				},
				{
					id: "lv-nicgale-sugu-laukumi-source",
					name: "sugu laukumi",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ahashzractgwdhcrtqrx/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'lv-nicgale-sugu-laukumi-layer',
						'type': 'fill',
						'source': 'lv-nicgale-sugu-laukumi-source',
						'source-layer': 'ahashzractgwdhcrtqrx',
						'layout': {
						
						},
						'paint': {
							'fill-opacity': 0.6,
							'fill-color': "#ff0000"
						}
					}
				},
				{
					id: "lv-nicgale-ia-sugus-source",
					name: "ia sugas",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/xvgebmtqfcikzstziwcd/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'lv-nicgale-ia-sugus-layer',
						'type': 'circle',
						'source': 'lv-nicgale-ia-sugus-source',
						'source-layer': 'xvgebmtqfcikzstziwcd',
						'layout': {
						
						},
						'paint': {
							'circle-radius': 4,
							'circle-color': "#ff0000"
						}
					}
				},
				{
					id: "lv-nicgale-aizsargajamie_koki-source",
					name: "aizsargajamie koki",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/kszsauxujxgdqhzykbot/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'lv-nicgale-aizsargajamie_koki-layer',
						'type': 'circle',
						'source': 'lv-nicgale-aizsargajamie_koki-source',
						'source-layer': 'kszsauxujxgdqhzykbot',
						'layout': {
						
						},
						'paint': {
							'circle-radius': 4,
							'circle-color': "#0000ff"
						}
					}
				},
				{
					id: "nicgale-allowed-areas",
					name: "Allowed areas",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.00jtw6r0'
					},
					layer:{
						'id': 'nicgale-allowed-areas-layer',
						'type': 'fill',
						'source': 'nicgale-allowed-areas',
						'source-layer': 'allowed_areas-5tf1kw',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#228B22',
							'fill-opacity': 1
						}
					}
				},
				{
					id: "nicgale-cleared-forest",
					name: "Cleared forest",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.aprhn143'
					},
					layer:{
						'id': 'nicgale-cleared-forest-layer',
						'type': 'fill',
						'source': 'nicgale-cleared-forest',
						'source-layer': 'cleared_forest-cz6b0x',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#4E8BD4',
							'fill-opacity': 1
						}
					}
				}
			]
		},
		{
			name: "Puikule",
			layers: [
				{
					id: "puikule-putnu-buffer-outer",
					name: "Birds nest red zone",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.lv-puikle-putnu-tiles'
					},
					layer:{
						'id': 'puikule-putnu-buffer-layer-red-zone',
						'type': 'fill',
						'source': 'puikule-putnu-buffer-outer',
						'source-layer': 'lv-puikle-putnu-buffer-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#FF0000',
							'fill-opacity': 1
						}
					}
				},
				{
					id: "puikule-putnu-buffer",
					name: "Birds buffer",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.lv-puikle-putnu-tiles'
					},
					layer:{
						'id': 'puikule-putnu-buffer-layer',
						'type': 'fill',
						'source': 'puikule-putnu-buffer',
						'source-layer': 'lv-puikle-putnu-buffer-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#228B22',
							'fill-opacity': 1
						},
						filter: ['!=', 'Liegums', 'Sarkans'],
					}
				},
				{
					id: "puikule-watercourse-buffer",
					name: "Watercourse buffer",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.lv-puikule-watercourse-tiles'
					},
					layer:{
						'id': 'puikule-watercourse-buffer-layer',
						'type': 'fill',
						'source': 'puikule-watercourse-buffer',
						'source-layer': 'lv-puikule-watercourse-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#4E8BD4',
							'fill-opacity': 1
						}
					}
				},
				{
					id: "puikule-udentecem",
					name: "Feeding buffer",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.lv-puikule-udentecem-tiles'
					},
					layer:{
						'id': 'puikule-udentecem-layer',
						'type': 'fill',
						'source': 'puikule-udentecem',
						'source-layer': 'lv-puikule-udentecem-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#696969',
							'fill-opacity': 1
						}
					}
				}
			]
		},
		{
			name: "Venta",
			layers: [
				{
					id: "venta-putnu-buffer-outer",
					name: "Birds nest red zone",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.lv-venta-putnu-tiles'
					},
					layer:{
						'id': 'venta-putnu-buffer-layer-red-zone',
						'type': 'fill',
						'source': 'venta-putnu-buffer-outer',
						'source-layer': 'lv-venta-putnu-buffer-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#FF0000',
							'fill-opacity': 1
						},
						filter: ['==', 'Liegums', 'Sarkans'],
					}
				},
				{
					id: "venta-putnu-buffer",
					name: "Birds buffer",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.lv-venta-putnu-tiles'
					},
					layer:{
						'id': 'venta-putnu-buffer-layer',
						'type': 'fill',
						'source': 'venta-putnu-buffer',
						'source-layer': 'lv-venta-putnu-buffer-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#228B22',
							'fill-opacity': 1
						},
						filter: ['!=', 'Liegums', 'Sarkans'],
					}
				},
				{
					id: "venta-watercourse-buffer",
					name: "Watercourse buffer",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.lv-venta-watercourse-tiles'
					},
					layer:{
						'id': 'venta-watercourse-buffer-layer',
						'type': 'fill',
						'source': 'venta-watercourse-buffer',
						'source-layer': 'lv-venta-watercourse-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#4E8BD4',
							'fill-opacity': 1
						}
					}
				},
				{
					id: "venta-udentecem",
					name: "Feeding buffer",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.lv-venta-udentecem-tiles'
					},
					layer:{
						'id': 'venta-udentecem-layer',
						'type': 'fill',
						'source': 'venta-udentecem',
						'source-layer': 'lv-venta-udentecem-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#696969',
							'fill-opacity': 1
						}
					}
				}
			]
		},





		{
			name: "Vecmikeli",
			layers: [
				{
					id: "vecmikeli-putnu-buffer-outer",
					name: "Birds nest red zone",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/Vecmikeli_Putnu_buferzonas_Final_07082024/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'vecmikeli-putnu-buffer-layer-red-zone',
						'type': 'fill',
						'source': 'vecmikeli-putnu-buffer-outer',
						'source-layer': 'Vecmikeli_Putnu_buferzonas_Final_07082024',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#FF0000',
							'fill-opacity': 1
						},
						filter: ['==', 'liegums', 'Sarkans'],
					}
				},
				{
					id: "vecmikeli-putnu-buffer",
					name: "Birds buffer",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/Vecmikeli_Putnu_buferzonas_Final_07082024/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'vecmikeli-putnu-buffer-layer',
						'type': 'fill',
						'source': 'vecmikeli-putnu-buffer',
						'source-layer': 'Vecmikeli_Putnu_buferzonas_Final_07082024',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#228B22',
							'fill-opacity': 1
						},
						filter: ['!=', 'liegums', 'Sarkans'],
					}
				},
				{
					id: "vecmikeli-watercourse-buffer",
					name: "Watercourse buffer",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/Vecmikeli_Siksparnu_udensteces_200m/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'vecmikeli-watercourse-buffer-layer',
						'type': 'fill',
						'source': 'vecmikeli-watercourse-buffer',
						'source-layer': 'Vecmikeli_Siksparnu_udensteces_200m',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#4E8BD4',
							'fill-opacity': 1
						}
					}
				},
				{
					id: "vecmikeli-udentecem",
					name: "Feeding buffer",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/Vecmikeli_Udentecem_buferzonas_Putni/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'vecmikeli-udentecem-layer',
						'type': 'fill',
						'source': 'vecmikeli-udentecem',
						'source-layer': 'Vecmikeli_Udentecem_buferzonas_Putni',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#696969',
							'fill-opacity': 1
						}
					}
				}
			]
		},
		{
			name: "Jaunklidzis",
			layers: [
				{
					id: "lv-jaunklidzis-pv-source",
					name: "Jaunklidzis PV",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/lv_jaunklidzis_pv/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'lv-jaunklidzis-pv-layer',
						'type': 'line',
						'source': 'lv-jaunklidzis-pv-source',
						'source-layer': 'lv_jaunklidzis_pv',
						'layout': {
						
						},
						'paint': {
							'line-color': '#000000',
							'line-width': 3
						}
					}
				}
			]
		},


		{
			name: "Cempi",
			layers: [
				{
					id: "lv-cempi-source",
					name: "Protected species",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/aqlxfpjlbnflmdkgvshi/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'lv-cempi-layer',
						'type': 'circle',
						'source': 'lv-cempi-source',
						'source-layer': 'aqlxfpjlbnflmdkgvshi',
						'layout': {
						
						},
						'paint': {
							'circle-color': '#000000',
							'circle-radius': 5
						}
					}
				},

				{
					id: "lv-cempi-birds-waterway-buffer-source",
					name: "Birds wateway buffer",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/omtsgrbtpboftgpbgaip/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'lv-cempi-birds-waterway-buffer-layer',
						'type': 'fill',
						'source': 'lv-cempi-birds-waterway-buffer-source',
						'source-layer': 'omtsgrbtpboftgpbgaip',
						'layout': {
						
						},
						'paint': {
							'fill-opacity': 0.6,
							'fill-color': [
											  "match",
											  ["get", "Liegums"],
											  ['Ļoti augts risks'],
											  "#fa3838",
											  ['Vidēji augsts risks'],
											  "#faf138",
											  "#000000"
											],
						}
					}
				},
				{
					id: "lv-cempi-bats-buffer-source",
					name: "Bats buffer",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/azziysndfzqsonexalyu/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'lv-cempi-bats-buffer-layer',
						'type': 'fill',
						'source': 'lv-cempi-bats-buffer-source',
						'source-layer': 'azziysndfzqsonexalyu',
						'layout': {
						
						},
						'paint': {
							'fill-opacity': 0.6,
							'fill-color': [
											  "match",
											  ["get", "Riski"],
											  ['Ļoti augsts risks'],
											  "#fa3838",
											  ['Vidēji augsts risks'],
											  "#faf138",
											  "#000000"
											],
						}
					}
				},
				{
					id: "lv-cempi-bird-nests-buffer-source",
					name: "Birds nest buffer",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/voswzfjgcpycgyyqxpeo/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'lv-cempi-bird-nests-buffer-layer',
						'type': 'fill',
						'source': 'lv-cempi-bird-nests-buffer-source',
						'source-layer': 'voswzfjgcpycgyyqxpeo',
						'layout': {
						
						},
						'paint': {
							'fill-opacity': 0.6,
							'fill-color': [
											  "match",
											  ["get", "Liegums"],
											  ['Ļoti augts risks'],
											  "#fa3838",
											  ['Vidēji augsts risks'],
											  "#faf138",
											  "#000000"
											],
						}
					}
				},
				{
					id: "lv-cempi-biotope-source",
					name: "Biotopes",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/yldhuuqxstywhxfphqea/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'lv-cempi-biotope-layer',
						'type': 'fill',
						'source': 'lv-cempi-biotope-source',
						'source-layer': 'yldhuuqxstywhxfphqea',
						'layout': {
						
						},
						'paint': {
							'fill-opacity': 0.6,
							'fill-color': "#fa3838",
						}
					}
				},
				{
					id: "lv-cempi-microreserves-source",
					name: "Micro reserves",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/jreqwhqbjmwvmsflpsiq/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'lv-cempi-microreserves-layer',
						'type': 'fill',
						'source': 'lv-cempi-microreserves-source',
						'source-layer': 'jreqwhqbjmwvmsflpsiq',
						'layout': {
						
						},
						'paint': {
							'fill-opacity': 0.6,
							'fill-color': "#000000",
						}
					}
				},
				{
					id: "lv-cempi-microreserves-buffer-source",
					name: "Micro reserves buffer",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/wctbcjdtnbsquxtlcqfd/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'lv-cempi-microreserves-buffer-layer',
						'type': 'fill',
						'source': 'lv-cempi-microreserves-buffer-source',
						'source-layer': 'wctbcjdtnbsquxtlcqfd',
						'layout': {
						
						},
						'paint': {
							'fill-opacity': 0.6,
							'fill-color': "#000000",
						}
					}
				},
				{
					id: "lv-cempi-big-old-tree-source",
					name: "Big old tree",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ybiecnqyacpldutdmvyd/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'lv-cempi-big-old-tree-layer',
						'type': 'circle',
						'source': 'lv-cempi-big-old-tree-source',
						'source-layer': 'ybiecnqyacpldutdmvyd',
						'layout': {
						
						},
						'paint': {
							'circle-color': '#000000',
							'circle-radius': 5
						}
					}
				}
			]
		},

		
		{
			name: "Osenieki",
			layers: [
				{
					id: "lv-osenieki-source",
					name: "Protected species",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/uqnpubwnqxluyaaopphw/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'lv-osenieki-layer',
						'type': 'circle',
						'source': 'lv-osenieki-source',
						'source-layer': 'uqnpubwnqxluyaaopphw',
						'layout': {
						
						},
						'paint': {
							'circle-color': '#000000',
							'circle-radius': 5
						}
					}
				},

				{
					id: "lv-osenieki-birds-waterway-buffer-source",
					name: "Birds wateway buffer",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/lvehptkwpimcmlcorwpo/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'lv-osenieki-birds-waterway-buffer-layer',
						'type': 'fill',
						'source': 'lv-osenieki-birds-waterway-buffer-source',
						'source-layer': 'lvehptkwpimcmlcorwpo',
						'layout': {
						
						},
						'paint': {
							'fill-opacity': 0.6,
							'fill-color': [
											  "match",
											  ["get", "Liegums"],
											  ['Ļoti augsts risks'],
											  "#fa3838",
											  ['Vidēji augsts risks'],
											  "#faf138",
											  "#000000"
											],
						}
					}
				},
				{
					id: "lv-osenieki-bats-buffer-source",
					name: "Bats buffer",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/sprldzcjdnbieqzrafbu/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'lv-osenieki-bats-buffer-layer',
						'type': 'fill',
						'source': 'lv-osenieki-bats-buffer-source',
						'source-layer': 'sprldzcjdnbieqzrafbu',
						'layout': {
						
						},
						'paint': {
							'fill-opacity': 0.6,
							'fill-color': '#fa3838',
						}
					}
				},
				{
					id: "lv-osenieki-bird-nests-buffer-source",
					name: "Birds nest buffer",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/qgksatqliwjbxhraxxlh/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'lv-osenieki-bird-nests-buffer-layer',
						'type': 'fill',
						'source': 'lv-osenieki-bird-nests-buffer-source',
						'source-layer': 'qgksatqliwjbxhraxxlh',
						'layout': {
						
						},
						'paint': {
							'fill-opacity': 0.6,
							'fill-color': [
											  "match",
											  ["get", "Risks"],
											  ['Ļoti augsts risks'],
											  "#fa3838",
											  ['Vidēji augsts risks'],
											  "#faf138",
											  "#000000"
											],
						}
					}
				},
				{
					id: "lv-osenieki-biotope-buffer-source",
					name: "Biotope buffer",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/pvufpokbwecccpjfhkpb/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'lv-osenieki-biotope-buffer-layer',
						'type': 'fill',
						'source': 'lv-osenieki-biotope-buffer-source',
						'source-layer': 'pvufpokbwecccpjfhkpb',
						'layout': {
						
						},
						'paint': {
							'fill-opacity': 0.6,
							'fill-color': [
											  "match",
											  ["get", "Risks"],
											  ['Ļoti augsts risks'],
											  "#fa3838",
											  ['Vidēji augsts risks'],
											  "#faf138",
											  "#000000"
											],
						}
					}
				},
				{
					id: "lv-osenieki-big-old-tree-buffer-source",
					name: "Big old tree buffer",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/qpllxycmaorcrphqjfpe/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'lv-osenieki-big-old-tree-buffer-layer',
						'type': 'fill',
						'source': 'lv-osenieki-big-old-tree-buffer-source',
						'source-layer': 'qpllxycmaorcrphqjfpe',
						'layout': {
						
						},
						'paint': {
							'fill-opacity': 0.6,
							'fill-color': [
											  "match",
											  ["get", "Risks"],
											  ['Ļoti augts risks'],
											  "#fa3838",
											  ['Vidēji augsts risks'],
											  "#faf138",
											  "#000000"
											],
						}
					}
				},
				{
					id: "lv-osenieki-power-lines-buffer-source",
					name: "Power lines buffer",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/agowxfugooixiksbvrph/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'lv-osenieki-power-lines-buffer-layer',
						'type': 'fill',
						'source': 'lv-osenieki-power-lines-buffer-source',
						'source-layer': 'agowxfugooixiksbvrph',
						'layout': {
						
						},
						'paint': {
							'fill-color': [
											  "match",
											  ["get", "Risks"],
											  ['Ļoti augts risks'],
											  "#fa3838",
											  ['Vidēji augsts risks'],
											  "#faf138",
											  "#000000"
											],
							'fill-opacity': [
											  "match",
											  ["get", "Risks"],
											  ['Ļoti augts risks'],
											  0.6,
											  ['Vidēji augsts risks'],
											  0,
											  0
											],
						}
					}
				}
			]
		},
		{
			name: "Jersika",
			layers: [
				    {
				        "id": "lv-atama-mdeqewjpurezlsratang-source",
				        "name": "Dizkoki",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/mdeqewjpurezlsratang/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-mdeqewjpurezlsratang-layer",
				            "type": "circle",
				            "source": "lv-atama-mdeqewjpurezlsratang-source",
				            "source-layer": "mdeqewjpurezlsratang",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-bscfqvkbwowpolgwomin-source",
				        "name": "Kulturvesturiskie_objekti",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/bscfqvkbwowpolgwomin/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-bscfqvkbwowpolgwomin-layer",
				            "type": "circle",
				            "source": "lv-atama-bscfqvkbwowpolgwomin-source",
				            "source-layer": "bscfqvkbwowpolgwomin",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-bywfinpnzhkvbeeahlvz-source",
				        "name": "Ligzdas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/bywfinpnzhkvbeeahlvz/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-bywfinpnzhkvbeeahlvz-layer",
				            "type": "circle",
				            "source": "lv-atama-bywfinpnzhkvbeeahlvz-source",
				            "source-layer": "bywfinpnzhkvbeeahlvz",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-exfxpagwhepmopvweeyo-source",
				        "name": "Ipasi_aizsargajamas_sugas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/exfxpagwhepmopvweeyo/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-exfxpagwhepmopvweeyo-layer",
				            "type": "circle",
				            "source": "lv-atama-exfxpagwhepmopvweeyo-source",
				            "source-layer": "exfxpagwhepmopvweeyo",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-crdttnjrxlgdnqtnbcng-source",
				        "name": "Apdzivoto_vietu_aizsargjosla_800m",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/crdttnjrxlgdnqtnbcng/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-crdttnjrxlgdnqtnbcng-layer",
				            "type": "fill",
				            "source": "lv-atama-crdttnjrxlgdnqtnbcng-source",
				            "source-layer": "crdttnjrxlgdnqtnbcng",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-yfpddxrhrdwsgxoazvot-source",
				        "name": "Biotopa_100m_buferzona",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/yfpddxrhrdwsgxoazvot/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-yfpddxrhrdwsgxoazvot-layer",
				            "type": "fill",
				            "source": "lv-atama-yfpddxrhrdwsgxoazvot-source",
				            "source-layer": "yfpddxrhrdwsgxoazvot",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-aniuntteurwifbdqlsix-source",
				        "name": "Biotopu_buferzona",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/aniuntteurwifbdqlsix/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-aniuntteurwifbdqlsix-layer",
				            "type": "fill",
				            "source": "lv-atama-aniuntteurwifbdqlsix-source",
				            "source-layer": "aniuntteurwifbdqlsix",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-kelzinqvifdwaxzibwcn-source",
				        "name": "Celu_infrasturkturas_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/kelzinqvifdwaxzibwcn/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-kelzinqvifdwaxzibwcn-layer",
				            "type": "fill",
				            "source": "lv-atama-kelzinqvifdwaxzibwcn-source",
				            "source-layer": "kelzinqvifdwaxzibwcn",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-mnbzgxrcywhscobmxzab-source",
				        "name": "Putnu_udenteces_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/mnbzgxrcywhscobmxzab/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-mnbzgxrcywhscobmxzab-layer",
				            "type": "fill",
				            "source": "lv-atama-mnbzgxrcywhscobmxzab-source",
				            "source-layer": "mnbzgxrcywhscobmxzab",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-hvlceuauglhpjnrnbbpo-source",
				        "name": "Siksparniem_nozimigas_alejas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/hvlceuauglhpjnrnbbpo/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-hvlceuauglhpjnrnbbpo-layer",
				            "type": "fill",
				            "source": "lv-atama-hvlceuauglhpjnrnbbpo-source",
				            "source-layer": "hvlceuauglhpjnrnbbpo",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-nrnwqtssaaqoxwipdvwd-source",
				        "name": "Siksparniem_nozimigas_mezaudzes",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/nrnwqtssaaqoxwipdvwd/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-nrnwqtssaaqoxwipdvwd-layer",
				            "type": "fill",
				            "source": "lv-atama-nrnwqtssaaqoxwipdvwd-source",
				            "source-layer": "nrnwqtssaaqoxwipdvwd",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-scwqpjhruekxfpigpppe-source",
				        "name": "Siksparnu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/scwqpjhruekxfpigpppe/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-scwqpjhruekxfpigpppe-layer",
				            "type": "fill",
				            "source": "lv-atama-scwqpjhruekxfpigpppe-source",
				            "source-layer": "scwqpjhruekxfpigpppe",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-pqrwadekxoebeotjcqyc-source",
				        "name": "Dizkoku_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/pqrwadekxoebeotjcqyc/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-pqrwadekxoebeotjcqyc-layer",
				            "type": "fill",
				            "source": "lv-atama-pqrwadekxoebeotjcqyc-source",
				            "source-layer": "pqrwadekxoebeotjcqyc",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-mjliwxvfdzfmqeedztlq-source",
				        "name": "Elektroenergetikas_infrastrukturas_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/mjliwxvfdzfmqeedztlq/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-mjliwxvfdzfmqeedztlq-layer",
				            "type": "fill",
				            "source": "lv-atama-mjliwxvfdzfmqeedztlq-source",
				            "source-layer": "mjliwxvfdzfmqeedztlq",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-pkjsqtiaqxajvwmevyxo-source",
				        "name": "Kulturvesturisko_objektu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/pkjsqtiaqxajvwmevyxo/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-pkjsqtiaqxajvwmevyxo-layer",
				            "type": "fill",
				            "source": "lv-atama-pkjsqtiaqxajvwmevyxo-source",
				            "source-layer": "pkjsqtiaqxajvwmevyxo",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-kbkatpqbygipsoqwavvq-source",
				        "name": "Mikroliegumi",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/kbkatpqbygipsoqwavvq/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-kbkatpqbygipsoqwavvq-layer",
				            "type": "fill",
				            "source": "lv-atama-kbkatpqbygipsoqwavvq-source",
				            "source-layer": "kbkatpqbygipsoqwavvq",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-owqltxumjwmerfxgpciq-source",
				        "name": "Mikroliegumu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/owqltxumjwmerfxgpciq/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-owqltxumjwmerfxgpciq-layer",
				            "type": "fill",
				            "source": "lv-atama-owqltxumjwmerfxgpciq-source",
				            "source-layer": "owqltxumjwmerfxgpciq",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-apzrkvdnrasqkfmtnncp-source",
				        "name": "NATURA_2000_teritorija",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/apzrkvdnrasqkfmtnncp/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-apzrkvdnrasqkfmtnncp-layer",
				            "type": "fill",
				            "source": "lv-atama-apzrkvdnrasqkfmtnncp-source",
				            "source-layer": "apzrkvdnrasqkfmtnncp",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-pbirmnmxcpazzjsfqseo-source",
				        "name": "Potencialas_NATURA2000_teritorijasPutnu_ligzdu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/pbirmnmxcpazzjsfqseo/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-pbirmnmxcpazzjsfqseo-layer",
				            "type": "fill",
				            "source": "lv-atama-pbirmnmxcpazzjsfqseo-source",
				            "source-layer": "pbirmnmxcpazzjsfqseo",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    }
				]
		},
		{
			name: "Kabile",
			layers: [
				    {
				        "id": "lv-atama-uwhafwlupagautitnxbq-source",
				        "name": "Dizkoki",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/uwhafwlupagautitnxbq/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-uwhafwlupagautitnxbq-layer",
				            "type": "circle",
				            "source": "lv-atama-uwhafwlupagautitnxbq-source",
				            "source-layer": "uwhafwlupagautitnxbq",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-zupqzbsuctndamqkpykz-source",
				        "name": "Ipasi_aizsargajamas_sugas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/zupqzbsuctndamqkpykz/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-zupqzbsuctndamqkpykz-layer",
				            "type": "circle",
				            "source": "lv-atama-zupqzbsuctndamqkpykz-source",
				            "source-layer": "zupqzbsuctndamqkpykz",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-jzozdsemszsbhrcaclxi-source",
				        "name": "Ligzda",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/jzozdsemszsbhrcaclxi/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-jzozdsemszsbhrcaclxi-layer",
				            "type": "circle",
				            "source": "lv-atama-jzozdsemszsbhrcaclxi-source",
				            "source-layer": "jzozdsemszsbhrcaclxi",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-kogbqsqcqwtoyeezpdnm-source",
				        "name": "Siksparnu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/kogbqsqcqwtoyeezpdnm/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-kogbqsqcqwtoyeezpdnm-layer",
				            "type": "fill",
				            "source": "lv-atama-kogbqsqcqwtoyeezpdnm-source",
				            "source-layer": "kogbqsqcqwtoyeezpdnm",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-mnttxsmcliygufcrrvll-source",
				        "name": "Biotopa_100m_buferzona",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/mnttxsmcliygufcrrvll/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-mnttxsmcliygufcrrvll-layer",
				            "type": "fill",
				            "source": "lv-atama-mnttxsmcliygufcrrvll-source",
				            "source-layer": "mnttxsmcliygufcrrvll",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-wztovacbrkaztzbcoscf-source",
				        "name": "Biotopu_buferzona",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/wztovacbrkaztzbcoscf/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-wztovacbrkaztzbcoscf-layer",
				            "type": "fill",
				            "source": "lv-atama-wztovacbrkaztzbcoscf-source",
				            "source-layer": "wztovacbrkaztzbcoscf",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-yxxmjqogoqjkeotrwgtm-source",
				        "name": "Celu_infrasturkturas_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/yxxmjqogoqjkeotrwgtm/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-yxxmjqogoqjkeotrwgtm-layer",
				            "type": "fill",
				            "source": "lv-atama-yxxmjqogoqjkeotrwgtm-source",
				            "source-layer": "yxxmjqogoqjkeotrwgtm",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-xsrbrwfknmdysmvwyjgu-source",
				        "name": "Putnu_udenteces_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/xsrbrwfknmdysmvwyjgu/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-xsrbrwfknmdysmvwyjgu-layer",
				            "type": "fill",
				            "source": "lv-atama-xsrbrwfknmdysmvwyjgu-source",
				            "source-layer": "xsrbrwfknmdysmvwyjgu",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-xnwohbhzthzeavuezwrl-source",
				        "name": "Siksparniem_nozimigas_mezaudzes",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/xnwohbhzthzeavuezwrl/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-xnwohbhzthzeavuezwrl-layer",
				            "type": "fill",
				            "source": "lv-atama-xnwohbhzthzeavuezwrl-source",
				            "source-layer": "xnwohbhzthzeavuezwrl",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-ydslaowdrtdnbuhpthte-source",
				        "name": "Apdzivoto_vietu_aizsargjosla_800m",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/ydslaowdrtdnbuhpthte/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-ydslaowdrtdnbuhpthte-layer",
				            "type": "fill",
				            "source": "lv-atama-ydslaowdrtdnbuhpthte-source",
				            "source-layer": "ydslaowdrtdnbuhpthte",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-paiztdthyrhixsfodlgy-source",
				        "name": "Dizkoku_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/paiztdthyrhixsfodlgy/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-paiztdthyrhixsfodlgy-layer",
				            "type": "fill",
				            "source": "lv-atama-paiztdthyrhixsfodlgy-source",
				            "source-layer": "paiztdthyrhixsfodlgy",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-qxqjkcsgiiziggbaigix-source",
				        "name": "Elektroenergetikas_infrastrukturas_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/qxqjkcsgiiziggbaigix/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-qxqjkcsgiiziggbaigix-layer",
				            "type": "fill",
				            "source": "lv-atama-qxqjkcsgiiziggbaigix-source",
				            "source-layer": "qxqjkcsgiiziggbaigix",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-eixhacnszkaqhhvxyguq-source",
				        "name": "Kulturvesturisko_objektu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/eixhacnszkaqhhvxyguq/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-eixhacnszkaqhhvxyguq-layer",
				            "type": "fill",
				            "source": "lv-atama-eixhacnszkaqhhvxyguq-source",
				            "source-layer": "eixhacnszkaqhhvxyguq",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-awnqjgppnlezjwtkujdd-source",
				        "name": "Mikroliegums",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/awnqjgppnlezjwtkujdd/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-awnqjgppnlezjwtkujdd-layer",
				            "type": "fill",
				            "source": "lv-atama-awnqjgppnlezjwtkujdd-source",
				            "source-layer": "awnqjgppnlezjwtkujdd",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-vlvtyusylhqhjvwehtpo-source",
				        "name": "Mikroliegumu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/vlvtyusylhqhjvwehtpo/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-vlvtyusylhqhjvwehtpo-layer",
				            "type": "fill",
				            "source": "lv-atama-vlvtyusylhqhjvwehtpo-source",
				            "source-layer": "vlvtyusylhqhjvwehtpo",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-ulkiflyjtrngflxhuhmq-source",
				        "name": "Putnu_ligzdu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/ulkiflyjtrngflxhuhmq/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-ulkiflyjtrngflxhuhmq-layer",
				            "type": "fill",
				            "source": "lv-atama-ulkiflyjtrngflxhuhmq-source",
				            "source-layer": "ulkiflyjtrngflxhuhmq",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-osxqzzgdlmdzcwoxvmre-source",
				        "name": "Potencialas_NATURA2000_teritorijas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/osxqzzgdlmdzcwoxvmre/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-osxqzzgdlmdzcwoxvmre-layer",
				            "type": "fill",
				            "source": "lv-atama-osxqzzgdlmdzcwoxvmre-source",
				            "source-layer": "osxqzzgdlmdzcwoxvmre",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    }
				]
		},
		{
			name: "Eleja",
			layers: [
				    {
				        "id": "lv-atama-xcbmteiiwtlkoqpnpfqd-source",
				        "name": "Dizkoki",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/xcbmteiiwtlkoqpnpfqd/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-xcbmteiiwtlkoqpnpfqd-layer",
				            "type": "circle",
				            "source": "lv-atama-xcbmteiiwtlkoqpnpfqd-source",
				            "source-layer": "xcbmteiiwtlkoqpnpfqd",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-utodyvwpdtmdtosuidkg-source",
				        "name": "Kulturvesturiskie_objekti",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/utodyvwpdtmdtosuidkg/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-utodyvwpdtmdtosuidkg-layer",
				            "type": "circle",
				            "source": "lv-atama-utodyvwpdtmdtosuidkg-source",
				            "source-layer": "utodyvwpdtmdtosuidkg",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-ktwnihlwkflykgkeeqdq-source",
				        "name": "Ligzda",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/ktwnihlwkflykgkeeqdq/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-ktwnihlwkflykgkeeqdq-layer",
				            "type": "circle",
				            "source": "lv-atama-ktwnihlwkflykgkeeqdq-source",
				            "source-layer": "ktwnihlwkflykgkeeqdq",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-vkjszrwsdtiddgvndina-source",
				        "name": "Ipasi_aizsargajamas_sugas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/vkjszrwsdtiddgvndina/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-vkjszrwsdtiddgvndina-layer",
				            "type": "circle",
				            "source": "lv-atama-vkjszrwsdtiddgvndina-source",
				            "source-layer": "vkjszrwsdtiddgvndina",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-pvpprzdmswxlumrplpnu-source",
				        "name": "Siksparnu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/pvpprzdmswxlumrplpnu/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-pvpprzdmswxlumrplpnu-layer",
				            "type": "fill",
				            "source": "lv-atama-pvpprzdmswxlumrplpnu-source",
				            "source-layer": "pvpprzdmswxlumrplpnu",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-lfdwmvztqbkvjkcchfhf-source",
				        "name": "Biotopa_100m_buferzona",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/lfdwmvztqbkvjkcchfhf/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-lfdwmvztqbkvjkcchfhf-layer",
				            "type": "fill",
				            "source": "lv-atama-lfdwmvztqbkvjkcchfhf-source",
				            "source-layer": "lfdwmvztqbkvjkcchfhf",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-fualnrcesfitflugkslz-source",
				        "name": "Biotopu_buferzona",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/fualnrcesfitflugkslz/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-fualnrcesfitflugkslz-layer",
				            "type": "fill",
				            "source": "lv-atama-fualnrcesfitflugkslz-source",
				            "source-layer": "fualnrcesfitflugkslz",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-vplkcojciwmmrmuztxuc-source",
				        "name": "Celu_infrasturkturas_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/vplkcojciwmmrmuztxuc/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-vplkcojciwmmrmuztxuc-layer",
				            "type": "fill",
				            "source": "lv-atama-vplkcojciwmmrmuztxuc-source",
				            "source-layer": "vplkcojciwmmrmuztxuc",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-beaisryvmidwtbgpiafd-source",
				        "name": "Putnu_ligzdu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/beaisryvmidwtbgpiafd/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-beaisryvmidwtbgpiafd-layer",
				            "type": "fill",
				            "source": "lv-atama-beaisryvmidwtbgpiafd-source",
				            "source-layer": "beaisryvmidwtbgpiafd",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-flildaaewqwywjtnfzog-source",
				        "name": "Putnu_udenteces_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/flildaaewqwywjtnfzog/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-flildaaewqwywjtnfzog-layer",
				            "type": "fill",
				            "source": "lv-atama-flildaaewqwywjtnfzog-source",
				            "source-layer": "flildaaewqwywjtnfzog",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-priquoigwfpjrcjenvmh-source",
				        "name": "Siksparniem_nozimigas_mezaudzes",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/priquoigwfpjrcjenvmh/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-priquoigwfpjrcjenvmh-layer",
				            "type": "fill",
				            "source": "lv-atama-priquoigwfpjrcjenvmh-source",
				            "source-layer": "priquoigwfpjrcjenvmh",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-abxidfqeyzeniozmqdez-source",
				        "name": "Apdzivoto_vietu_aizsargjosla_800m",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/abxidfqeyzeniozmqdez/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-abxidfqeyzeniozmqdez-layer",
				            "type": "fill",
				            "source": "lv-atama-abxidfqeyzeniozmqdez-source",
				            "source-layer": "abxidfqeyzeniozmqdez",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-zoyscfjwcozkvvlsvccc-source",
				        "name": "Dizkoku_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/zoyscfjwcozkvvlsvccc/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-zoyscfjwcozkvvlsvccc-layer",
				            "type": "fill",
				            "source": "lv-atama-zoyscfjwcozkvvlsvccc-source",
				            "source-layer": "zoyscfjwcozkvvlsvccc",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-aoulifdtjhfxgdnolrom-source",
				        "name": "Elektroenergetikas_infrastrukturas_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/aoulifdtjhfxgdnolrom/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-aoulifdtjhfxgdnolrom-layer",
				            "type": "fill",
				            "source": "lv-atama-aoulifdtjhfxgdnolrom-source",
				            "source-layer": "aoulifdtjhfxgdnolrom",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-kdumzfmywutlwxmaplcr-source",
				        "name": "Kulturvesturisko_objektu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/kdumzfmywutlwxmaplcr/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-kdumzfmywutlwxmaplcr-layer",
				            "type": "fill",
				            "source": "lv-atama-kdumzfmywutlwxmaplcr-source",
				            "source-layer": "kdumzfmywutlwxmaplcr",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-tmnntjwzytszzdlqdcdb-source",
				        "name": "Mikroeligumi",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/tmnntjwzytszzdlqdcdb/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-tmnntjwzytszzdlqdcdb-layer",
				            "type": "fill",
				            "source": "lv-atama-tmnntjwzytszzdlqdcdb-source",
				            "source-layer": "tmnntjwzytszzdlqdcdb",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-bajbomjzakeyyminhysi-source",
				        "name": "Mikroliegumu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/bajbomjzakeyyminhysi/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-bajbomjzakeyyminhysi-layer",
				            "type": "fill",
				            "source": "lv-atama-bajbomjzakeyyminhysi-source",
				            "source-layer": "bajbomjzakeyyminhysi",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-ukrkaaokhlclvflbxtcn-source",
				        "name": "NATURA_2000_teritorija",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/ukrkaaokhlclvflbxtcn/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-ukrkaaokhlclvflbxtcn-layer",
				            "type": "fill",
				            "source": "lv-atama-ukrkaaokhlclvflbxtcn-source",
				            "source-layer": "ukrkaaokhlclvflbxtcn",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    }
				]
		},
		{
			name: "Broceni",
			layers: [
					{
				        "id": "lv-atama-eqgzlueiengotyybvvdd-source",
				        "name": "Dizkoki",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/eqgzlueiengotyybvvdd/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-eqgzlueiengotyybvvdd-layer",
				            "type": "circle",
				            "source": "lv-atama-eqgzlueiengotyybvvdd-source",
				            "source-layer": "eqgzlueiengotyybvvdd",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-rpbhzrxybdacrznopbdn-source",
				        "name": "Kulturvesturiskie_objekti",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/rpbhzrxybdacrznopbdn/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-rpbhzrxybdacrznopbdn-layer",
				            "type": "circle",
				            "source": "lv-atama-rpbhzrxybdacrznopbdn-source",
				            "source-layer": "rpbhzrxybdacrznopbdn",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-jvklhaewrdgfharrouaz-source",
				        "name": "Ligzda",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/jvklhaewrdgfharrouaz/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-jvklhaewrdgfharrouaz-layer",
				            "type": "circle",
				            "source": "lv-atama-jvklhaewrdgfharrouaz-source",
				            "source-layer": "jvklhaewrdgfharrouaz",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-fzokrobwbzteqywcmpef-source",
				        "name": "Ipasi_aizsargajamas_sugas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/fzokrobwbzteqywcmpef/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-fzokrobwbzteqywcmpef-layer",
				            "type": "circle",
				            "source": "lv-atama-fzokrobwbzteqywcmpef-source",
				            "source-layer": "fzokrobwbzteqywcmpef",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-lhvcofznaqrvmchnvjwe-source",
				        "name": "Siksparnu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/lhvcofznaqrvmchnvjwe/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-lhvcofznaqrvmchnvjwe-layer",
				            "type": "fill",
				            "source": "lv-atama-lhvcofznaqrvmchnvjwe-source",
				            "source-layer": "lhvcofznaqrvmchnvjwe",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-zvawfwaanoocjoqugliv-source",
				        "name": "Biotopa_100m_buferzona",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/zvawfwaanoocjoqugliv/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-zvawfwaanoocjoqugliv-layer",
				            "type": "fill",
				            "source": "lv-atama-zvawfwaanoocjoqugliv-source",
				            "source-layer": "zvawfwaanoocjoqugliv",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-oecpbtwatinraobsbzvw-source",
				        "name": "Biotopu_buferzona",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/oecpbtwatinraobsbzvw/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-oecpbtwatinraobsbzvw-layer",
				            "type": "fill",
				            "source": "lv-atama-oecpbtwatinraobsbzvw-source",
				            "source-layer": "oecpbtwatinraobsbzvw",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-msajelbglvxqwewhcjny-source",
				        "name": "Celu_infrasturkturas_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/msajelbglvxqwewhcjny/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-msajelbglvxqwewhcjny-layer",
				            "type": "fill",
				            "source": "lv-atama-msajelbglvxqwewhcjny-source",
				            "source-layer": "msajelbglvxqwewhcjny",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-qojnvqkddgsccjhanvgz-source",
				        "name": "Civilas_aizsardzibas_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/qojnvqkddgsccjhanvgz/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-qojnvqkddgsccjhanvgz-layer",
				            "type": "fill",
				            "source": "lv-atama-qojnvqkddgsccjhanvgz-source",
				            "source-layer": "qojnvqkddgsccjhanvgz",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-ghneoceintvnkxgyswhm-source",
				        "name": "Putnu_ligzdu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/ghneoceintvnkxgyswhm/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-ghneoceintvnkxgyswhm-layer",
				            "type": "fill",
				            "source": "lv-atama-ghneoceintvnkxgyswhm-source",
				            "source-layer": "ghneoceintvnkxgyswhm",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-umtvoianonycnvycbwhr-source",
				        "name": "Putnu_udenteces_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/umtvoianonycnvycbwhr/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-umtvoianonycnvycbwhr-layer",
				            "type": "fill",
				            "source": "lv-atama-umtvoianonycnvycbwhr-source",
				            "source-layer": "umtvoianonycnvycbwhr",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-xkmulewcpotyifunaano-source",
				        "name": "Putnu_udenteces_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/xkmulewcpotyifunaano/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-xkmulewcpotyifunaano-layer",
				            "type": "fill",
				            "source": "lv-atama-xkmulewcpotyifunaano-source",
				            "source-layer": "xkmulewcpotyifunaano",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-cactrdaijenrohbdsqyw-source",
				        "name": "Apdzīvoto_vietu_bugerzona_800",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/cactrdaijenrohbdsqyw/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-cactrdaijenrohbdsqyw-layer",
				            "type": "fill",
				            "source": "lv-atama-cactrdaijenrohbdsqyw-source",
				            "source-layer": "cactrdaijenrohbdsqyw",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-xgaqxocpqmmjinvcjldo-source",
				        "name": "Dizkoku_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/xgaqxocpqmmjinvcjldo/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-xgaqxocpqmmjinvcjldo-layer",
				            "type": "fill",
				            "source": "lv-atama-xgaqxocpqmmjinvcjldo-source",
				            "source-layer": "xgaqxocpqmmjinvcjldo",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-qpubhfffaniyvcmxezec-source",
				        "name": "Elektroenergetikas_infrastrukturas_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/qpubhfffaniyvcmxezec/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-qpubhfffaniyvcmxezec-layer",
				            "type": "fill",
				            "source": "lv-atama-qpubhfffaniyvcmxezec-source",
				            "source-layer": "qpubhfffaniyvcmxezec",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-sjsurcrhkesyyzzvnmxs-source",
				        "name": "Kulturvesturisko_objektu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/sjsurcrhkesyyzzvnmxs/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-sjsurcrhkesyyzzvnmxs-layer",
				            "type": "fill",
				            "source": "lv-atama-sjsurcrhkesyyzzvnmxs-source",
				            "source-layer": "sjsurcrhkesyyzzvnmxs",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-gudlogpwzoytsdevhqdc-source",
				        "name": "Mikroliegums",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/gudlogpwzoytsdevhqdc/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-gudlogpwzoytsdevhqdc-layer",
				            "type": "fill",
				            "source": "lv-atama-gudlogpwzoytsdevhqdc-source",
				            "source-layer": "gudlogpwzoytsdevhqdc",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-rptagluazdhrpsvurzxd-source",
				        "name": "Mikroliegumu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/rptagluazdhrpsvurzxd/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-rptagluazdhrpsvurzxd-layer",
				            "type": "fill",
				            "source": "lv-atama-rptagluazdhrpsvurzxd-source",
				            "source-layer": "rptagluazdhrpsvurzxd",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-qatfakdnygjjilvhjqtb-source",
				        "name": "NATURA_2000_teritorija",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/qatfakdnygjjilvhjqtb/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-qatfakdnygjjilvhjqtb-layer",
				            "type": "fill",
				            "source": "lv-atama-qatfakdnygjjilvhjqtb-source",
				            "source-layer": "qatfakdnygjjilvhjqtb",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-bcdbdwvqvxiifzmbrlxi-source",
				        "name": "Potencialas_NATURA2000_teritorijas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/bcdbdwvqvxiifzmbrlxi/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-bcdbdwvqvxiifzmbrlxi-layer",
				            "type": "fill",
				            "source": "lv-atama-bcdbdwvqvxiifzmbrlxi-source",
				            "source-layer": "bcdbdwvqvxiifzmbrlxi",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    }
				]
		},
		{
			name: "Pierobeza Auce",
			layers: [
					{
				        "id": "lv-atama-cdttowuqwaspgzlkrtlz-source",
				        "name": "Dizkoki",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/cdttowuqwaspgzlkrtlz/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-cdttowuqwaspgzlkrtlz-layer",
				            "type": "circle",
				            "source": "lv-atama-cdttowuqwaspgzlkrtlz-source",
				            "source-layer": "cdttowuqwaspgzlkrtlz",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-gprmsikfonhzhjowxpyy-source",
				        "name": "Kulturvesturiskie_objekti",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/gprmsikfonhzhjowxpyy/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-gprmsikfonhzhjowxpyy-layer",
				            "type": "circle",
				            "source": "lv-atama-gprmsikfonhzhjowxpyy-source",
				            "source-layer": "gprmsikfonhzhjowxpyy",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-yoawiolyftvwzcmozvao-source",
				        "name": "Ligzda",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/yoawiolyftvwzcmozvao/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-yoawiolyftvwzcmozvao-layer",
				            "type": "circle",
				            "source": "lv-atama-yoawiolyftvwzcmozvao-source",
				            "source-layer": "yoawiolyftvwzcmozvao",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-vnvhmmzhqkitmediiegd-source",
				        "name": "Ipasi_aizsargajamas_sugas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/vnvhmmzhqkitmediiegd/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-vnvhmmzhqkitmediiegd-layer",
				            "type": "circle",
				            "source": "lv-atama-vnvhmmzhqkitmediiegd-source",
				            "source-layer": "vnvhmmzhqkitmediiegd",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-kdoxtzjawlwnkccgqjtx-source",
				        "name": "Apdzivoto_vietu_aizsargjosla_800m",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/kdoxtzjawlwnkccgqjtx/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-kdoxtzjawlwnkccgqjtx-layer",
				            "type": "fill",
				            "source": "lv-atama-kdoxtzjawlwnkccgqjtx-source",
				            "source-layer": "kdoxtzjawlwnkccgqjtx",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-aqssdhqvhocsqtksxrzi-source",
				        "name": "Biotopa_100m_buferzona",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/aqssdhqvhocsqtksxrzi/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-aqssdhqvhocsqtksxrzi-layer",
				            "type": "fill",
				            "source": "lv-atama-aqssdhqvhocsqtksxrzi-source",
				            "source-layer": "aqssdhqvhocsqtksxrzi",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-nyocdztjgzdlbtikqjlq-source",
				        "name": "Biotopu_buferzona",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/nyocdztjgzdlbtikqjlq/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-nyocdztjgzdlbtikqjlq-layer",
				            "type": "fill",
				            "source": "lv-atama-nyocdztjgzdlbtikqjlq-source",
				            "source-layer": "nyocdztjgzdlbtikqjlq",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-hqvzhftomibfijfnzqyk-source",
				        "name": "Celu_infrasturkturas_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/hqvzhftomibfijfnzqyk/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-hqvzhftomibfijfnzqyk-layer",
				            "type": "fill",
				            "source": "lv-atama-hqvzhftomibfijfnzqyk-source",
				            "source-layer": "hqvzhftomibfijfnzqyk",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-kjbursyfaxvdgztaxhbo-source",
				        "name": "Putnu_udenteces_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/kjbursyfaxvdgztaxhbo/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-kjbursyfaxvdgztaxhbo-layer",
				            "type": "fill",
				            "source": "lv-atama-kjbursyfaxvdgztaxhbo-source",
				            "source-layer": "kjbursyfaxvdgztaxhbo",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-xvfgerfhqmzcgpbkwjlt-source",
				        "name": "Siksparniem_nozimigas_mezaudzes",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/xvfgerfhqmzcgpbkwjlt/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-xvfgerfhqmzcgpbkwjlt-layer",
				            "type": "fill",
				            "source": "lv-atama-xvfgerfhqmzcgpbkwjlt-source",
				            "source-layer": "xvfgerfhqmzcgpbkwjlt",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-ugwfdrsqtbvlftsoypgm-source",
				        "name": "Siksparnu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/ugwfdrsqtbvlftsoypgm/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-ugwfdrsqtbvlftsoypgm-layer",
				            "type": "fill",
				            "source": "lv-atama-ugwfdrsqtbvlftsoypgm-source",
				            "source-layer": "ugwfdrsqtbvlftsoypgm",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-gazulisqzlnybpmciilm-source",
				        "name": "Zemes_vienības",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/gazulisqzlnybpmciilm/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-gazulisqzlnybpmciilm-layer",
				            "type": "fill",
				            "source": "lv-atama-gazulisqzlnybpmciilm-source",
				            "source-layer": "gazulisqzlnybpmciilm",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-gxzqxppmlmvaxokvhqeg-source",
				        "name": "Dizkoku_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/gxzqxppmlmvaxokvhqeg/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-gxzqxppmlmvaxokvhqeg-layer",
				            "type": "fill",
				            "source": "lv-atama-gxzqxppmlmvaxokvhqeg-source",
				            "source-layer": "gxzqxppmlmvaxokvhqeg",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-kvkenhyhpstwkzxuuzuo-source",
				        "name": "Elektroenergetikas_infrastrukturas_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/kvkenhyhpstwkzxuuzuo/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-kvkenhyhpstwkzxuuzuo-layer",
				            "type": "fill",
				            "source": "lv-atama-kvkenhyhpstwkzxuuzuo-source",
				            "source-layer": "kvkenhyhpstwkzxuuzuo",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-qmuggftptleoltjtwvjc-source",
				        "name": "Mikroliegumi",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/qmuggftptleoltjtwvjc/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-qmuggftptleoltjtwvjc-layer",
				            "type": "fill",
				            "source": "lv-atama-qmuggftptleoltjtwvjc-source",
				            "source-layer": "qmuggftptleoltjtwvjc",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-dmjmuawitabsbfnspjjk-source",
				        "name": "Mikroliegumu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/dmjmuawitabsbfnspjjk/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-dmjmuawitabsbfnspjjk-layer",
				            "type": "fill",
				            "source": "lv-atama-dmjmuawitabsbfnspjjk-source",
				            "source-layer": "dmjmuawitabsbfnspjjk",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-taocotdxdvrltlwikxwf-source",
				        "name": "NATURA_2000_teritorija",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/taocotdxdvrltlwikxwf/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-taocotdxdvrltlwikxwf-layer",
				            "type": "fill",
				            "source": "lv-atama-taocotdxdvrltlwikxwf-source",
				            "source-layer": "taocotdxdvrltlwikxwf",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-nzshumysqdcnbalxnmem-source",
				        "name": "Putnu_ligzdu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/nzshumysqdcnbalxnmem/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-nzshumysqdcnbalxnmem-layer",
				            "type": "fill",
				            "source": "lv-atama-nzshumysqdcnbalxnmem-source",
				            "source-layer": "nzshumysqdcnbalxnmem",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    }
				]
		},
		{
			name: "Vaives",
			layers: [
								{
				        "id": "lv-atama-kmjbodfkwupacwtpaytn-source",
				        "name": "Ipasi_aizsargajamas_sugas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/kmjbodfkwupacwtpaytn/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-kmjbodfkwupacwtpaytn-layer",
				            "type": "circle",
				            "source": "lv-atama-kmjbodfkwupacwtpaytn-source",
				            "source-layer": "kmjbodfkwupacwtpaytn",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-ceeriredzicjrhljanjc-source",
				        "name": "Kulturvesturiskie_objekti",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/ceeriredzicjrhljanjc/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-ceeriredzicjrhljanjc-layer",
				            "type": "circle",
				            "source": "lv-atama-ceeriredzicjrhljanjc-source",
				            "source-layer": "ceeriredzicjrhljanjc",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-jwanzpfvderqhhczlsgy-source",
				        "name": "Ligzdas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/jwanzpfvderqhhczlsgy/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-jwanzpfvderqhhczlsgy-layer",
				            "type": "circle",
				            "source": "lv-atama-jwanzpfvderqhhczlsgy-source",
				            "source-layer": "jwanzpfvderqhhczlsgy",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-vadehgbdwfxfwqqavywb-source",
				        "name": "Apdzivoto_vietu_aizsargjosla_800m",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/vadehgbdwfxfwqqavywb/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-vadehgbdwfxfwqqavywb-layer",
				            "type": "fill",
				            "source": "lv-atama-vadehgbdwfxfwqqavywb-source",
				            "source-layer": "vadehgbdwfxfwqqavywb",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-nfjrugzlzsilagpndhue-source",
				        "name": "Biotopa_100m_buferzona",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/nfjrugzlzsilagpndhue/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-nfjrugzlzsilagpndhue-layer",
				            "type": "fill",
				            "source": "lv-atama-nfjrugzlzsilagpndhue-source",
				            "source-layer": "nfjrugzlzsilagpndhue",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-qkpnmajiboptnpzmrnzs-source",
				        "name": "Biotopu_buferzona",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/qkpnmajiboptnpzmrnzs/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-qkpnmajiboptnpzmrnzs-layer",
				            "type": "fill",
				            "source": "lv-atama-qkpnmajiboptnpzmrnzs-source",
				            "source-layer": "qkpnmajiboptnpzmrnzs",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-pldrjhcimtfbuavzkluw-source",
				        "name": "Celu_infrasturkturas_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/pldrjhcimtfbuavzkluw/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-pldrjhcimtfbuavzkluw-layer",
				            "type": "fill",
				            "source": "lv-atama-pldrjhcimtfbuavzkluw-source",
				            "source-layer": "pldrjhcimtfbuavzkluw",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-ighmvnefyrlhafzctxnf-source",
				        "name": "Siksparniem_nozimigas_mezaudzes",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/ighmvnefyrlhafzctxnf/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-ighmvnefyrlhafzctxnf-layer",
				            "type": "fill",
				            "source": "lv-atama-ighmvnefyrlhafzctxnf-source",
				            "source-layer": "ighmvnefyrlhafzctxnf",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-qcovdhotlseujilnwlbz-source",
				        "name": "Siksparnu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/qcovdhotlseujilnwlbz/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-qcovdhotlseujilnwlbz-layer",
				            "type": "fill",
				            "source": "lv-atama-qcovdhotlseujilnwlbz-source",
				            "source-layer": "qcovdhotlseujilnwlbz",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-tkkgtxfvwgfbmcznpibh-source",
				        "name": "Zemes_vienības",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/tkkgtxfvwgfbmcznpibh/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-tkkgtxfvwgfbmcznpibh-layer",
				            "type": "fill",
				            "source": "lv-atama-tkkgtxfvwgfbmcznpibh-source",
				            "source-layer": "tkkgtxfvwgfbmcznpibh",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-abihbgrwlesqjlnpfxgq-source",
				        "name": "Kulturvesturisko_objektu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/abihbgrwlesqjlnpfxgq/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-abihbgrwlesqjlnpfxgq-layer",
				            "type": "fill",
				            "source": "lv-atama-abihbgrwlesqjlnpfxgq-source",
				            "source-layer": "abihbgrwlesqjlnpfxgq",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-dzlsuqqxwybbyutelyrn-source",
				        "name": "Mikroliegumi",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/dzlsuqqxwybbyutelyrn/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-dzlsuqqxwybbyutelyrn-layer",
				            "type": "fill",
				            "source": "lv-atama-dzlsuqqxwybbyutelyrn-source",
				            "source-layer": "dzlsuqqxwybbyutelyrn",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-szrokidyrnfzghvzrzxd-source",
				        "name": "Putnu_ligzdu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/szrokidyrnfzghvzrzxd/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-szrokidyrnfzghvzrzxd-layer",
				            "type": "fill",
				            "source": "lv-atama-szrokidyrnfzghvzrzxd-source",
				            "source-layer": "szrokidyrnfzghvzrzxd",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-hlaaesdmzyqzwpoxopzg-source",
				        "name": "Putnu_udenteces_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/hlaaesdmzyqzwpoxopzg/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-hlaaesdmzyqzwpoxopzg-layer",
				            "type": "fill",
				            "source": "lv-atama-hlaaesdmzyqzwpoxopzg-source",
				            "source-layer": "hlaaesdmzyqzwpoxopzg",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    }
				]
		},

		{
			name: "Osenieki Lutrini",
			layers:[
								{
				        "id": "lv-atama-lycathrtnxxuxirexuxl-source",
				        "name": "Dizkoki",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/lycathrtnxxuxirexuxl/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-lycathrtnxxuxirexuxl-layer",
				            "type": "circle",
				            "source": "lv-atama-lycathrtnxxuxirexuxl-source",
				            "source-layer": "lycathrtnxxuxirexuxl",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-hdgucyfoujabhveolhhw-source",
				        "name": "Ipasi_aizsargajamas_sugas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/hdgucyfoujabhveolhhw/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-hdgucyfoujabhveolhhw-layer",
				            "type": "circle",
				            "source": "lv-atama-hdgucyfoujabhveolhhw-source",
				            "source-layer": "hdgucyfoujabhveolhhw",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-hzekdxibzyefodvthqgv-source",
				        "name": "Ligzda",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/hzekdxibzyefodvthqgv/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-hzekdxibzyefodvthqgv-layer",
				            "type": "circle",
				            "source": "lv-atama-hzekdxibzyefodvthqgv-source",
				            "source-layer": "hzekdxibzyefodvthqgv",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-fjddxrtqloxcwtempedd-source",
				        "name": "Apdzivoto_vietu_aizsargjosla_800m",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/fjddxrtqloxcwtempedd/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-fjddxrtqloxcwtempedd-layer",
				            "type": "fill",
				            "source": "lv-atama-fjddxrtqloxcwtempedd-source",
				            "source-layer": "fjddxrtqloxcwtempedd",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-ekflhojlrrnnzjzhairc-source",
				        "name": "Biotopa_100m_buferzona",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/ekflhojlrrnnzjzhairc/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-ekflhojlrrnnzjzhairc-layer",
				            "type": "fill",
				            "source": "lv-atama-ekflhojlrrnnzjzhairc-source",
				            "source-layer": "ekflhojlrrnnzjzhairc",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-rtxzpqcrgurxfzqzlemb-source",
				        "name": "Biotopu_buferzona",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/rtxzpqcrgurxfzqzlemb/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-rtxzpqcrgurxfzqzlemb-layer",
				            "type": "fill",
				            "source": "lv-atama-rtxzpqcrgurxfzqzlemb-source",
				            "source-layer": "rtxzpqcrgurxfzqzlemb",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-vkyytwngtqiwwwoxacbv-source",
				        "name": "Celu_infrasturkturas_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/vkyytwngtqiwwwoxacbv/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-vkyytwngtqiwwwoxacbv-layer",
				            "type": "fill",
				            "source": "lv-atama-vkyytwngtqiwwwoxacbv-source",
				            "source-layer": "vkyytwngtqiwwwoxacbv",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-qzoduttcyvtsxvtofspy-source",
				        "name": "Putnu_udenteces_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/qzoduttcyvtsxvtofspy/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-qzoduttcyvtsxvtofspy-layer",
				            "type": "fill",
				            "source": "lv-atama-qzoduttcyvtsxvtofspy-source",
				            "source-layer": "qzoduttcyvtsxvtofspy",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-lbjutvmaxcjhgyvlwdbi-source",
				        "name": "Siksparnu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/lbjutvmaxcjhgyvlwdbi/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-lbjutvmaxcjhgyvlwdbi-layer",
				            "type": "fill",
				            "source": "lv-atama-lbjutvmaxcjhgyvlwdbi-source",
				            "source-layer": "lbjutvmaxcjhgyvlwdbi",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-yzrnpcctbmqnhprlkgun-source",
				        "name": "Zemes_vienibas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/yzrnpcctbmqnhprlkgun/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-yzrnpcctbmqnhprlkgun-layer",
				            "type": "fill",
				            "source": "lv-atama-yzrnpcctbmqnhprlkgun-source",
				            "source-layer": "yzrnpcctbmqnhprlkgun",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-kxfbksamytxsqehkpcva-source",
				        "name": "Dizkoku_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/kxfbksamytxsqehkpcva/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-kxfbksamytxsqehkpcva-layer",
				            "type": "fill",
				            "source": "lv-atama-kxfbksamytxsqehkpcva-source",
				            "source-layer": "kxfbksamytxsqehkpcva",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-ipmbyhiymtfabjecunkb-source",
				        "name": "Elektroenergetikas_infrastrukturas_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/ipmbyhiymtfabjecunkb/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-ipmbyhiymtfabjecunkb-layer",
				            "type": "fill",
				            "source": "lv-atama-ipmbyhiymtfabjecunkb-source",
				            "source-layer": "ipmbyhiymtfabjecunkb",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-sxqmqwobtoduuxriqszz-source",
				        "name": "Mikroliegums",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/sxqmqwobtoduuxriqszz/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-sxqmqwobtoduuxriqszz-layer",
				            "type": "fill",
				            "source": "lv-atama-sxqmqwobtoduuxriqszz-source",
				            "source-layer": "sxqmqwobtoduuxriqszz",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-gkwufzxkzlvggiacyrhj-source",
				        "name": "Mikroliegumu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/gkwufzxkzlvggiacyrhj/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-gkwufzxkzlvggiacyrhj-layer",
				            "type": "fill",
				            "source": "lv-atama-gkwufzxkzlvggiacyrhj-source",
				            "source-layer": "gkwufzxkzlvggiacyrhj",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-mpqsgikfbwsmyhjxpbfp-source",
				        "name": "Putnu_ligzdu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/mpqsgikfbwsmyhjxpbfp/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-mpqsgikfbwsmyhjxpbfp-layer",
				            "type": "fill",
				            "source": "lv-atama-mpqsgikfbwsmyhjxpbfp-source",
				            "source-layer": "mpqsgikfbwsmyhjxpbfp",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    }
				]
		},
		{
			name: "Livani Nicgale",
			layers:[
				{
				        "id": "lv-atama-uuqfjrgcoebtddzhnqxm-source",
				        "name": "Ipasi_aizsargajamas_sugas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/uuqfjrgcoebtddzhnqxm/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-uuqfjrgcoebtddzhnqxm-layer",
				            "type": "circle",
				            "source": "lv-atama-uuqfjrgcoebtddzhnqxm-source",
				            "source-layer": "uuqfjrgcoebtddzhnqxm",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-wxcshlpqgfanhqoymyjl-source",
				        "name": "Kulturvesturiskie_objekti",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/wxcshlpqgfanhqoymyjl/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-wxcshlpqgfanhqoymyjl-layer",
				            "type": "circle",
				            "source": "lv-atama-wxcshlpqgfanhqoymyjl-source",
				            "source-layer": "wxcshlpqgfanhqoymyjl",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-ncrisrwwmiddzoaziyqu-source",
				        "name": "Ligzdas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/ncrisrwwmiddzoaziyqu/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-ncrisrwwmiddzoaziyqu-layer",
				            "type": "circle",
				            "source": "lv-atama-ncrisrwwmiddzoaziyqu-source",
				            "source-layer": "ncrisrwwmiddzoaziyqu",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-bwgugtbbngvqhxmtcveh-source",
				        "name": "Apdzivoto_vietu_aizsargjosla_800m",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/bwgugtbbngvqhxmtcveh/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-bwgugtbbngvqhxmtcveh-layer",
				            "type": "fill",
				            "source": "lv-atama-bwgugtbbngvqhxmtcveh-source",
				            "source-layer": "bwgugtbbngvqhxmtcveh",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-whlhlscyombspuanhhnh-source",
				        "name": "Biotopa_100m_buferzona",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/whlhlscyombspuanhhnh/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-whlhlscyombspuanhhnh-layer",
				            "type": "fill",
				            "source": "lv-atama-whlhlscyombspuanhhnh-source",
				            "source-layer": "whlhlscyombspuanhhnh",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-pjwipyvckjwqdwmwkpsx-source",
				        "name": "Biotopu_buferzona",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/pjwipyvckjwqdwmwkpsx/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-pjwipyvckjwqdwmwkpsx-layer",
				            "type": "fill",
				            "source": "lv-atama-pjwipyvckjwqdwmwkpsx-source",
				            "source-layer": "pjwipyvckjwqdwmwkpsx",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-obbzbdsxxycydbrfiecw-source",
				        "name": "Celu_infrasturkturas_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/obbzbdsxxycydbrfiecw/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-obbzbdsxxycydbrfiecw-layer",
				            "type": "fill",
				            "source": "lv-atama-obbzbdsxxycydbrfiecw-source",
				            "source-layer": "obbzbdsxxycydbrfiecw",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-svslhunvzuspoukwcwag-source",
				        "name": "Elektroenergetikas_infrastrukturas_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/svslhunvzuspoukwcwag/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-svslhunvzuspoukwcwag-layer",
				            "type": "fill",
				            "source": "lv-atama-svslhunvzuspoukwcwag-source",
				            "source-layer": "svslhunvzuspoukwcwag",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-dndlwjgorcljnjpcchfs-source",
				        "name": "Siksparniem_nozimigas_mezaudzes",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/dndlwjgorcljnjpcchfs/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-dndlwjgorcljnjpcchfs-layer",
				            "type": "fill",
				            "source": "lv-atama-dndlwjgorcljnjpcchfs-source",
				            "source-layer": "dndlwjgorcljnjpcchfs",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-aykvggfdkstwgirxylne-source",
				        "name": "Siksparnu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/aykvggfdkstwgirxylne/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-aykvggfdkstwgirxylne-layer",
				            "type": "fill",
				            "source": "lv-atama-aykvggfdkstwgirxylne-source",
				            "source-layer": "aykvggfdkstwgirxylne",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-ohdiylzphcenekltpucj-source",
				        "name": "Zemes_vienības",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/ohdiylzphcenekltpucj/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-ohdiylzphcenekltpucj-layer",
				            "type": "fill",
				            "source": "lv-atama-ohdiylzphcenekltpucj-source",
				            "source-layer": "ohdiylzphcenekltpucj",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-zzgghixtmityvstwffqf-source",
				        "name": "Kulturvesturisko_objektu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/zzgghixtmityvstwffqf/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-zzgghixtmityvstwffqf-layer",
				            "type": "fill",
				            "source": "lv-atama-zzgghixtmityvstwffqf-source",
				            "source-layer": "zzgghixtmityvstwffqf",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-czulymkjoihiqugbxkvw-source",
				        "name": "Mikroliegumi",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/czulymkjoihiqugbxkvw/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-czulymkjoihiqugbxkvw-layer",
				            "type": "fill",
				            "source": "lv-atama-czulymkjoihiqugbxkvw-source",
				            "source-layer": "czulymkjoihiqugbxkvw",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-gcvkfamrvfbmhghkeqpp-source",
				        "name": "Mikroliegumu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/gcvkfamrvfbmhghkeqpp/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-gcvkfamrvfbmhghkeqpp-layer",
				            "type": "fill",
				            "source": "lv-atama-gcvkfamrvfbmhghkeqpp-source",
				            "source-layer": "gcvkfamrvfbmhghkeqpp",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-vxbcwzdzsawighlzrsii-source",
				        "name": "Putnu_ligzdu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/vxbcwzdzsawighlzrsii/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-vxbcwzdzsawighlzrsii-layer",
				            "type": "fill",
				            "source": "lv-atama-vxbcwzdzsawighlzrsii-source",
				            "source-layer": "vxbcwzdzsawighlzrsii",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-fkeyarvfemkboqdtflxq-source",
				        "name": "Putnu_udenteces_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/fkeyarvfemkboqdtflxq/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-fkeyarvfemkboqdtflxq-layer",
				            "type": "fill",
				            "source": "lv-atama-fkeyarvfemkboqdtflxq-source",
				            "source-layer": "fkeyarvfemkboqdtflxq",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    }
				]
		},
		{
			name: "Lielauce",
			layers: [
				{
				        "id": "lv-atama-fiywenswzkovesffonzv-source",
				        "name": "Dizkoki",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/fiywenswzkovesffonzv/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-fiywenswzkovesffonzv-layer",
				            "type": "circle",
				            "source": "lv-atama-fiywenswzkovesffonzv-source",
				            "source-layer": "fiywenswzkovesffonzv",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-dggmppriqnvxwjwrtogq-source",
				        "name": "Parki",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/dggmppriqnvxwjwrtogq/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-dggmppriqnvxwjwrtogq-layer",
				            "type": "circle",
				            "source": "lv-atama-dggmppriqnvxwjwrtogq-source",
				            "source-layer": "dggmppriqnvxwjwrtogq",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-wdjjcxvsrrzduysjnjdk-source",
				        "name": "Ligzda",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/wdjjcxvsrrzduysjnjdk/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-wdjjcxvsrrzduysjnjdk-layer",
				            "type": "circle",
				            "source": "lv-atama-wdjjcxvsrrzduysjnjdk-source",
				            "source-layer": "wdjjcxvsrrzduysjnjdk",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-fihqwhqcwitqszcujojt-source",
				        "name": "Ipasi_aizsargajamas_sugas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/fihqwhqcwitqszcujojt/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-fihqwhqcwitqszcujojt-layer",
				            "type": "circle",
				            "source": "lv-atama-fihqwhqcwitqszcujojt-source",
				            "source-layer": "fihqwhqcwitqszcujojt",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-bimmbysaxurqyomhsylm-source",
				        "name": "Apdzivoto_vietu_aizsargjosla_800m",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/bimmbysaxurqyomhsylm/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-bimmbysaxurqyomhsylm-layer",
				            "type": "fill",
				            "source": "lv-atama-bimmbysaxurqyomhsylm-source",
				            "source-layer": "bimmbysaxurqyomhsylm",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-hxuahlvvbjtaqrgnumbf-source",
				        "name": "Biotopa_100m_buferzona",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/hxuahlvvbjtaqrgnumbf/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-hxuahlvvbjtaqrgnumbf-layer",
				            "type": "fill",
				            "source": "lv-atama-hxuahlvvbjtaqrgnumbf-source",
				            "source-layer": "hxuahlvvbjtaqrgnumbf",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-vbwtlsnfqcpwpblvaxmv-source",
				        "name": "Biotopu_buferzona",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/vbwtlsnfqcpwpblvaxmv/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-vbwtlsnfqcpwpblvaxmv-layer",
				            "type": "fill",
				            "source": "lv-atama-vbwtlsnfqcpwpblvaxmv-source",
				            "source-layer": "vbwtlsnfqcpwpblvaxmv",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-nuxucgkyajxpdszuzfoi-source",
				        "name": "Celu_infrasturkturas_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/nuxucgkyajxpdszuzfoi/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-nuxucgkyajxpdszuzfoi-layer",
				            "type": "fill",
				            "source": "lv-atama-nuxucgkyajxpdszuzfoi-source",
				            "source-layer": "nuxucgkyajxpdszuzfoi",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-xuiqzlnjwbfbgjctcvvy-source",
				        "name": "Civilas_aizsardzibas_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/xuiqzlnjwbfbgjctcvvy/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-xuiqzlnjwbfbgjctcvvy-layer",
				            "type": "fill",
				            "source": "lv-atama-xuiqzlnjwbfbgjctcvvy-source",
				            "source-layer": "xuiqzlnjwbfbgjctcvvy",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-gfqudyprtnillrihqvju-source",
				        "name": "Putnu_udenteces_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/gfqudyprtnillrihqvju/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-gfqudyprtnillrihqvju-layer",
				            "type": "fill",
				            "source": "lv-atama-gfqudyprtnillrihqvju-source",
				            "source-layer": "gfqudyprtnillrihqvju",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-nvrskwwdfmfvktatxydb-source",
				        "name": "Siksparniem_nozimigi_dendroloģiskie_stadijumu",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/nvrskwwdfmfvktatxydb/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-nvrskwwdfmfvktatxydb-layer",
				            "type": "fill",
				            "source": "lv-atama-nvrskwwdfmfvktatxydb-source",
				            "source-layer": "nvrskwwdfmfvktatxydb",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-cntzhvvzpsmamqvfpzwq-source",
				        "name": "Siksparnu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/cntzhvvzpsmamqvfpzwq/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-cntzhvvzpsmamqvfpzwq-layer",
				            "type": "fill",
				            "source": "lv-atama-cntzhvvzpsmamqvfpzwq-source",
				            "source-layer": "cntzhvvzpsmamqvfpzwq",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-ponqgnpuajgdebxwrvwt-source",
				        "name": "Zemes_vienības",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/ponqgnpuajgdebxwrvwt/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-ponqgnpuajgdebxwrvwt-layer",
				            "type": "fill",
				            "source": "lv-atama-ponqgnpuajgdebxwrvwt-source",
				            "source-layer": "ponqgnpuajgdebxwrvwt",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-gbdvgedfkvmomrdlhgqq-source",
				        "name": "Dizkoku_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/gbdvgedfkvmomrdlhgqq/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-gbdvgedfkvmomrdlhgqq-layer",
				            "type": "fill",
				            "source": "lv-atama-gbdvgedfkvmomrdlhgqq-source",
				            "source-layer": "gbdvgedfkvmomrdlhgqq",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-uvxcaajfvfkngqqftaqz-source",
				        "name": "Elektroenergetikas_infrastrukturas_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/uvxcaajfvfkngqqftaqz/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-uvxcaajfvfkngqqftaqz-layer",
				            "type": "fill",
				            "source": "lv-atama-uvxcaajfvfkngqqftaqz-source",
				            "source-layer": "uvxcaajfvfkngqqftaqz",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-ycsxfffzpmiywagjyabv-source",
				        "name": "Kulturvesturisko_objektu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/ycsxfffzpmiywagjyabv/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-ycsxfffzpmiywagjyabv-layer",
				            "type": "fill",
				            "source": "lv-atama-ycsxfffzpmiywagjyabv-source",
				            "source-layer": "ycsxfffzpmiywagjyabv",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-gvqspuzvlmtgzrxrtiwh-source",
				        "name": "Mikroliegums",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/gvqspuzvlmtgzrxrtiwh/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-gvqspuzvlmtgzrxrtiwh-layer",
				            "type": "fill",
				            "source": "lv-atama-gvqspuzvlmtgzrxrtiwh-source",
				            "source-layer": "gvqspuzvlmtgzrxrtiwh",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-xwuedaloajkufstcqxur-source",
				        "name": "Mikroliegumu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/xwuedaloajkufstcqxur/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-xwuedaloajkufstcqxur-layer",
				            "type": "fill",
				            "source": "lv-atama-xwuedaloajkufstcqxur-source",
				            "source-layer": "xwuedaloajkufstcqxur",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-ngmpscesvkflmulbtkxr-source",
				        "name": "NATURA_2000_teritorija",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/ngmpscesvkflmulbtkxr/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-ngmpscesvkflmulbtkxr-layer",
				            "type": "fill",
				            "source": "lv-atama-ngmpscesvkflmulbtkxr-source",
				            "source-layer": "ngmpscesvkflmulbtkxr",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-crcwnpbgnudybnzaockz-source",
				        "name": "Potencialas_NATURA2000_teritorijas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/crcwnpbgnudybnzaockz/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-crcwnpbgnudybnzaockz-layer",
				            "type": "fill",
				            "source": "lv-atama-crcwnpbgnudybnzaockz-source",
				            "source-layer": "crcwnpbgnudybnzaockz",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-jwzpxcljsgxpfbasajpg-source",
				        "name": "Putnu_ligzdu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/jwzpxcljsgxpfbasajpg/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-jwzpxcljsgxpfbasajpg-layer",
				            "type": "fill",
				            "source": "lv-atama-jwzpxcljsgxpfbasajpg-source",
				            "source-layer": "jwzpxcljsgxpfbasajpg",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    }
				]
		},
		{
			name: "Kukas Vipe",
			layers:[
				 	{
				        "id": "lv-atama-sjlnmuxnnxktgemeuner-source",
				        "name": "Dizkoki",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/sjlnmuxnnxktgemeuner/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-sjlnmuxnnxktgemeuner-layer",
				            "type": "circle",
				            "source": "lv-atama-sjlnmuxnnxktgemeuner-source",
				            "source-layer": "sjlnmuxnnxktgemeuner",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-gjbeuxftsmxszanmaesv-source",
				        "name": "Ipasi_aizsargajamas_sugas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/gjbeuxftsmxszanmaesv/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-gjbeuxftsmxszanmaesv-layer",
				            "type": "circle",
				            "source": "lv-atama-gjbeuxftsmxszanmaesv-source",
				            "source-layer": "gjbeuxftsmxszanmaesv",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-czzhynfmrgkaqkbkjhaw-source",
				        "name": "Ligzda",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/czzhynfmrgkaqkbkjhaw/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-czzhynfmrgkaqkbkjhaw-layer",
				            "type": "circle",
				            "source": "lv-atama-czzhynfmrgkaqkbkjhaw-source",
				            "source-layer": "czzhynfmrgkaqkbkjhaw",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-nsdauhjckewnxuxysacd-source",
				        "name": "Siksparniem_nozimigas_mezaudzes",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/nsdauhjckewnxuxysacd/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-nsdauhjckewnxuxysacd-layer",
				            "type": "fill",
				            "source": "lv-atama-nsdauhjckewnxuxysacd-source",
				            "source-layer": "nsdauhjckewnxuxysacd",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-bifdmdcscheolwlfovrh-source",
				        "name": "Apdzivoto_vietu_aizsargjosla_800m",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/bifdmdcscheolwlfovrh/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-bifdmdcscheolwlfovrh-layer",
				            "type": "fill",
				            "source": "lv-atama-bifdmdcscheolwlfovrh-source",
				            "source-layer": "bifdmdcscheolwlfovrh",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-jcdsmolrefahizfvxhgu-source",
				        "name": "Biotopa_100m_buferzona",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/jcdsmolrefahizfvxhgu/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-jcdsmolrefahizfvxhgu-layer",
				            "type": "fill",
				            "source": "lv-atama-jcdsmolrefahizfvxhgu-source",
				            "source-layer": "jcdsmolrefahizfvxhgu",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-pfbsgktnfjzqquduakhu-source",
				        "name": "Biotopu_buferzona",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/pfbsgktnfjzqquduakhu/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-pfbsgktnfjzqquduakhu-layer",
				            "type": "fill",
				            "source": "lv-atama-pfbsgktnfjzqquduakhu-source",
				            "source-layer": "pfbsgktnfjzqquduakhu",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-qqgviehskutgjyindooy-source",
				        "name": "Celu_infrasturkturas_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/qqgviehskutgjyindooy/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-qqgviehskutgjyindooy-layer",
				            "type": "fill",
				            "source": "lv-atama-qqgviehskutgjyindooy-source",
				            "source-layer": "qqgviehskutgjyindooy",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-mrqrtnzwlahimtpypile-source",
				        "name": "Kulturvesturisko_objektu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/mrqrtnzwlahimtpypile/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-mrqrtnzwlahimtpypile-layer",
				            "type": "fill",
				            "source": "lv-atama-mrqrtnzwlahimtpypile-source",
				            "source-layer": "mrqrtnzwlahimtpypile",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-eorrsquvvfehhvbnpqoe-source",
				        "name": "Putnu_udenteces_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/eorrsquvvfehhvbnpqoe/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-eorrsquvvfehhvbnpqoe-layer",
				            "type": "fill",
				            "source": "lv-atama-eorrsquvvfehhvbnpqoe-source",
				            "source-layer": "eorrsquvvfehhvbnpqoe",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-ghljahzihwzfegcycxax-source",
				        "name": "Zemes_vienības",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/ghljahzihwzfegcycxax/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-ghljahzihwzfegcycxax-layer",
				            "type": "fill",
				            "source": "lv-atama-ghljahzihwzfegcycxax-source",
				            "source-layer": "ghljahzihwzfegcycxax",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-ymrpjpkcesrczyvojnki-source",
				        "name": "Dizkoku_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/ymrpjpkcesrczyvojnki/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-ymrpjpkcesrczyvojnki-layer",
				            "type": "fill",
				            "source": "lv-atama-ymrpjpkcesrczyvojnki-source",
				            "source-layer": "ymrpjpkcesrczyvojnki",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-mbrtfzzkynpflufqeehd-source",
				        "name": "Elektroenergetikas_infrastrukturas_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/mbrtfzzkynpflufqeehd/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-mbrtfzzkynpflufqeehd-layer",
				            "type": "fill",
				            "source": "lv-atama-mbrtfzzkynpflufqeehd-source",
				            "source-layer": "mbrtfzzkynpflufqeehd",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    }
				]
		},
		{
			name: "Blomes Zakisi",
			layers: [
					{
				        "id": "lv-atama-mrcbnmtdnvxhzihfbapx-source",
				        "name": "Dizkoki",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/mrcbnmtdnvxhzihfbapx/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-mrcbnmtdnvxhzihfbapx-layer",
				            "type": "circle",
				            "source": "lv-atama-mrcbnmtdnvxhzihfbapx-source",
				            "source-layer": "mrcbnmtdnvxhzihfbapx",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-yzzwyfmjlfevufagoebp-source",
				        "name": "Ipasi_aizsargajamas_sugas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/yzzwyfmjlfevufagoebp/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-yzzwyfmjlfevufagoebp-layer",
				            "type": "circle",
				            "source": "lv-atama-yzzwyfmjlfevufagoebp-source",
				            "source-layer": "yzzwyfmjlfevufagoebp",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-odkoozflcjwimstkihbu-source",
				        "name": "Ligzdas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/odkoozflcjwimstkihbu/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-odkoozflcjwimstkihbu-layer",
				            "type": "circle",
				            "source": "lv-atama-odkoozflcjwimstkihbu-source",
				            "source-layer": "odkoozflcjwimstkihbu",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-bgbfdptpmjtfjwmgnbhj-source",
				        "name": "Apdzivoto_vietu_aizsargjosla_800m",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/bgbfdptpmjtfjwmgnbhj/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-bgbfdptpmjtfjwmgnbhj-layer",
				            "type": "fill",
				            "source": "lv-atama-bgbfdptpmjtfjwmgnbhj-source",
				            "source-layer": "bgbfdptpmjtfjwmgnbhj",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-jhxaybjqfblszxajotqr-source",
				        "name": "Biotopa_100m_buferzona",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/jhxaybjqfblszxajotqr/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-jhxaybjqfblszxajotqr-layer",
				            "type": "fill",
				            "source": "lv-atama-jhxaybjqfblszxajotqr-source",
				            "source-layer": "jhxaybjqfblszxajotqr",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-ffvajhddoqqkbkublzbk-source",
				        "name": "Biotopu_buferzona",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/ffvajhddoqqkbkublzbk/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-ffvajhddoqqkbkublzbk-layer",
				            "type": "fill",
				            "source": "lv-atama-ffvajhddoqqkbkublzbk-source",
				            "source-layer": "ffvajhddoqqkbkublzbk",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-zjpmnmzecxoscdaljkjp-source",
				        "name": "Celu_infrasturkturas_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/zjpmnmzecxoscdaljkjp/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-zjpmnmzecxoscdaljkjp-layer",
				            "type": "fill",
				            "source": "lv-atama-zjpmnmzecxoscdaljkjp-source",
				            "source-layer": "zjpmnmzecxoscdaljkjp",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-cvavijeoehvfkxueafxu-source",
				        "name": "Siksparniem_nozimigas_alejas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/cvavijeoehvfkxueafxu/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-cvavijeoehvfkxueafxu-layer",
				            "type": "fill",
				            "source": "lv-atama-cvavijeoehvfkxueafxu-source",
				            "source-layer": "cvavijeoehvfkxueafxu",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-goqulgjipmouxkgnverd-source",
				        "name": "Siksparniem_nozimigas_mezaudzes",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/goqulgjipmouxkgnverd/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-goqulgjipmouxkgnverd-layer",
				            "type": "fill",
				            "source": "lv-atama-goqulgjipmouxkgnverd-source",
				            "source-layer": "goqulgjipmouxkgnverd",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-ufiihmpnvhzxtjvbppqs-source",
				        "name": "Siksparnu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/ufiihmpnvhzxtjvbppqs/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-ufiihmpnvhzxtjvbppqs-layer",
				            "type": "fill",
				            "source": "lv-atama-ufiihmpnvhzxtjvbppqs-source",
				            "source-layer": "ufiihmpnvhzxtjvbppqs",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-kfrcutqsxlymuaniqzrn-source",
				        "name": "Dizkoku_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/kfrcutqsxlymuaniqzrn/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-kfrcutqsxlymuaniqzrn-layer",
				            "type": "fill",
				            "source": "lv-atama-kfrcutqsxlymuaniqzrn-source",
				            "source-layer": "kfrcutqsxlymuaniqzrn",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-mmfuqkvpxekugjusplon-source",
				        "name": "Elektroenergetikas_infrastrukturas_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/mmfuqkvpxekugjusplon/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-mmfuqkvpxekugjusplon-layer",
				            "type": "fill",
				            "source": "lv-atama-mmfuqkvpxekugjusplon-source",
				            "source-layer": "mmfuqkvpxekugjusplon",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-mmlgppmbrblyeznujmzn-source",
				        "name": "Kulturvesturisko_objektu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/mmlgppmbrblyeznujmzn/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-mmlgppmbrblyeznujmzn-layer",
				            "type": "fill",
				            "source": "lv-atama-mmlgppmbrblyeznujmzn-source",
				            "source-layer": "mmlgppmbrblyeznujmzn",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-plvdaepsgiudflyynvlp-source",
				        "name": "Mikroliegumi",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/plvdaepsgiudflyynvlp/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-plvdaepsgiudflyynvlp-layer",
				            "type": "fill",
				            "source": "lv-atama-plvdaepsgiudflyynvlp-source",
				            "source-layer": "plvdaepsgiudflyynvlp",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-dvxxtgojlmcpzxihznkp-source",
				        "name": "Mikroliegumu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/dvxxtgojlmcpzxihznkp/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-dvxxtgojlmcpzxihznkp-layer",
				            "type": "fill",
				            "source": "lv-atama-dvxxtgojlmcpzxihznkp-source",
				            "source-layer": "dvxxtgojlmcpzxihznkp",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-dcwxmcwkboaznsphxahx-source",
				        "name": "NATURA_2000_teritorija",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/dcwxmcwkboaznsphxahx/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-dcwxmcwkboaznsphxahx-layer",
				            "type": "fill",
				            "source": "lv-atama-dcwxmcwkboaznsphxahx-source",
				            "source-layer": "dcwxmcwkboaznsphxahx",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-xfywedcsbsagvoxwtsmo-source",
				        "name": "Potencialo_veja_turbinu_zemes_vienibas_izvertejums",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/xfywedcsbsagvoxwtsmo/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-xfywedcsbsagvoxwtsmo-layer",
				            "type": "fill",
				            "source": "lv-atama-xfywedcsbsagvoxwtsmo-source",
				            "source-layer": "xfywedcsbsagvoxwtsmo",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-stvakbwcezithzwobgry-source",
				        "name": "Putnu_ligzdu_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/stvakbwcezithzwobgry/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-stvakbwcezithzwobgry-layer",
				            "type": "fill",
				            "source": "lv-atama-stvakbwcezithzwobgry-source",
				            "source-layer": "stvakbwcezithzwobgry",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    },
				    {
				        "id": "lv-atama-htrlirkftelksvnekkpd-source",
				        "name": "Putnu_udenteces_buferzonas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/htrlirkftelksvnekkpd/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-htrlirkftelksvnekkpd-layer",
				            "type": "fill",
				            "source": "lv-atama-htrlirkftelksvnekkpd-source",
				            "source-layer": "htrlirkftelksvnekkpd",
				            "layout": {},
				            "paint": {
				                "fill-opacity": 0.6,
				                "fill-color": [
				                    "match",
				                    [
				                        "get",
				                        "Risks"
				                    ],
				                    [
				                        "Ļoti augsts risks"
				                    ],
				                    "#fa3838",
				                    [
				                        "Vidēji augsts risks"
				                    ],
				                    "#faf138",
				                    "#000000"
				                ]
				            }
				        }
				    }
				]
		},
		{
			name: "Jaunsati",
			layers: [	
					{
				        "id": "lv-atama-xnfmbcmgftuhzfyatswh-source",
				        "name": "Ligzda",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/xnfmbcmgftuhzfyatswh/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-xnfmbcmgftuhzfyatswh-layer",
				            "type": "circle",
				            "source": "lv-atama-xnfmbcmgftuhzfyatswh-source",
				            "source-layer": "xnfmbcmgftuhzfyatswh",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-xkddyyaxnwggofwpvfdf-source",
				        "name": "Kulturvesturiskie_objekti",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/xkddyyaxnwggofwpvfdf/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-xkddyyaxnwggofwpvfdf-layer",
				            "type": "circle",
				            "source": "lv-atama-xkddyyaxnwggofwpvfdf-source",
				            "source-layer": "xkddyyaxnwggofwpvfdf",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
				    {
				        "id": "lv-atama-mvawqqyybmbgsjzucitg-source",
				        "name": "Ipasi_aizsargajamas_sugas",
				        "defaultChecked": false,
				        "source": {
				            "type": "vector",
				            "tiles": [
				                "https://tiles.vindrtech.com/tiles/mvawqqyybmbgsjzucitg/{z}/{x}/{y}"
				            ]
				        },
				        "layer": {
				            "id": "lv-atama-mvawqqyybmbgsjzucitg-layer",
				            "type": "circle",
				            "source": "lv-atama-mvawqqyybmbgsjzucitg-source",
				            "source-layer": "mvawqqyybmbgsjzucitg",
				            "layout": {},
				            "paint": {
				                "circle-color": "#000000",
				                "circle-radius": 5
				            }
				        }
				    },
					{
						    "id": "lv-atama-ebdxkdthydkcyjvzwxmc-source",
						    "name": "Apdzivoto_vietu_buferzona_800m",
						    "defaultChecked": false,
						    "source": {
						        "type": "vector",
						        "tiles": [
						            "https://tiles.vindrtech.com/tiles/ebdxkdthydkcyjvzwxmc/{z}/{x}/{y}"
						        ]
						    },
						    "layer": {
						        "id": "lv-atama-ebdxkdthydkcyjvzwxmc-layer",
						        "type": "fill",
						        "source": "lv-atama-ebdxkdthydkcyjvzwxmc-source",
						        "source-layer": "ebdxkdthydkcyjvzwxmc",
						        "layout": {},
						        'paint': {
									'fill-opacity': 0.6,
									'fill-color': [
													  "match",
													  ["get", "Risks"],
													  ['Ļoti augts risks / Very high risk'],
													  "#fa3838",
													  ['Vidēji augsts risks'],
													  "#faf138",
													  "#000000"
													],
								}
						    }
						},
						{
						    "id": "lv-atama-swozeyiitnktxyumbvzx-source",
						    "name": "Biotopi_augsts_risks",
						    "defaultChecked": false,
						    "source": {
						        "type": "vector",
						        "tiles": [
						            "https://tiles.vindrtech.com/tiles/swozeyiitnktxyumbvzx/{z}/{x}/{y}"
						        ]
						    },
						    "layer": {
						        "id": "lv-atama-swozeyiitnktxyumbvzx-layer",
						        "type": "fill",
						        "source": "lv-atama-swozeyiitnktxyumbvzx-source",
						        "source-layer": "swozeyiitnktxyumbvzx",
						        "layout": {},
						        'paint': {
									'fill-opacity': 0.6,
									'fill-color': [
													  "match",
													  ["get", "Risks"],
													  ['Ļoti augts risks / Very high risk'],
													  "#fa3838",
													  ['Vidēji augsts risks'],
													  "#faf138",
													  "#000000"
													],
								}
						    }
						},
						{
						    "id": "lv-atama-hxkcwunatnequblnxdhy-source",
						    "name": "Cela_infrastrukturas_buferzona",
						    "defaultChecked": false,
						    "source": {
						        "type": "vector",
						        "tiles": [
						            "https://tiles.vindrtech.com/tiles/hxkcwunatnequblnxdhy/{z}/{x}/{y}"
						        ]
						    },
						    "layer": {
						        "id": "lv-atama-hxkcwunatnequblnxdhy-layer",
						        "type": "fill",
						        "source": "lv-atama-hxkcwunatnequblnxdhy-source",
						        "source-layer": "hxkcwunatnequblnxdhy",
						        "layout": {},
						        'paint': {
									'fill-opacity': 0.6,
									'fill-color': [
													  "match",
													  ["get", "Risks"],
													  ['Ļoti augts risks / Very high risk'],
													  "#fa3838",
													  ['Vidēji augsts risks'],
													  "#faf138",
													  "#000000"
													],
								}
						    }
						},
						{
						    "id": "lv-atama-vhayxuypengjtyasvhxp-source",
						    "name": "Elektroenergetikas_infrastrukturas_buferzona",
						    "defaultChecked": false,
						    "source": {
						        "type": "vector",
						        "tiles": [
						            "https://tiles.vindrtech.com/tiles/vhayxuypengjtyasvhxp/{z}/{x}/{y}"
						        ]
						    },
						    "layer": {
						        "id": "lv-atama-vhayxuypengjtyasvhxp-layer",
						        "type": "fill",
						        "source": "lv-atama-vhayxuypengjtyasvhxp-source",
						        "source-layer": "vhayxuypengjtyasvhxp",
						        "layout": {},
						        'paint': {
									'fill-opacity': 0.6,
									'fill-color': [
													  "match",
													  ["get", "Risks"],
													  ['Ļoti augts risks / Very high risk'],
													  "#fa3838",
													  ['Vidēji augsts risks'],
													  "#faf138",
													  "#000000"
													],
								}
						    }
						},
						{
						    "id": "lv-atama-djfysgokowwvjhuxcmta-source",
						    "name": "Kulturvesturisko_objektu_buferzonas",
						    "defaultChecked": false,
						    "source": {
						        "type": "vector",
						        "tiles": [
						            "https://tiles.vindrtech.com/tiles/djfysgokowwvjhuxcmta/{z}/{x}/{y}"
						        ]
						    },
						    "layer": {
						        "id": "lv-atama-djfysgokowwvjhuxcmta-layer",
						        "type": "fill",
						        "source": "lv-atama-djfysgokowwvjhuxcmta-source",
						        "source-layer": "djfysgokowwvjhuxcmta",
						        "layout": {},
						        'paint': {
									'fill-opacity': 0.6,
									'fill-color': [
													  "match",
													  ["get", "Risks"],
													  ['Ļoti augts risks / Very high risk'],
													  "#fa3838",
													  ['Vidēji augsts risks'],
													  "#faf138",
													  "#000000"
													],
								}
						    }
						},
						{
						    "id": "lv-atama-kbrlychccblpfbjscldr-source",
						    "name": "Mikroliegums",
						    "defaultChecked": false,
						    "source": {
						        "type": "vector",
						        "tiles": [
						            "https://tiles.vindrtech.com/tiles/kbrlychccblpfbjscldr/{z}/{x}/{y}"
						        ]
						    },
						    "layer": {
						        "id": "lv-atama-kbrlychccblpfbjscldr-layer",
						        "type": "fill",
						        "source": "lv-atama-kbrlychccblpfbjscldr-source",
						        "source-layer": "kbrlychccblpfbjscldr",
						        "layout": {},
						        'paint': {
									'fill-opacity': 0.6,
									'fill-color': [
													  "match",
													  ["get", "Risks"],
													  ['Ļoti augts risks / Very high risk'],
													  "#fa3838",
													  ['Vidēji augsts risks'],
													  "#faf138",
													  "#000000"
													],
								}
						    }
						},
						{
						    "id": "lv-atama-obqsqgqaoigzdoyayajh-source",
						    "name": "Mikroliegumu_buferzonas",
						    "defaultChecked": false,
						    "source": {
						        "type": "vector",
						        "tiles": [
						            "https://tiles.vindrtech.com/tiles/obqsqgqaoigzdoyayajh/{z}/{x}/{y}"
						        ]
						    },
						    "layer": {
						        "id": "lv-atama-obqsqgqaoigzdoyayajh-layer",
						        "type": "fill",
						        "source": "lv-atama-obqsqgqaoigzdoyayajh-source",
						        "source-layer": "obqsqgqaoigzdoyayajh",
						        "layout": {},
						        'paint': {
									'fill-opacity': 0.6,
									'fill-color': [
													  "match",
													  ["get", "Risks"],
													  ['Ļoti augts risks / Very high risk'],
													  "#fa3838",
													  ['Vidēji augsts risks'],
													  "#faf138",
													  "#000000"
													],
								}
						    }
						},
						{
						    "id": "lv-atama-eistviltcrpzeacjtujf-source",
						    "name": "Potencialo_biotopu_Biotopu_100m_buferzona_videjs_risks",
						    "defaultChecked": false,
						    "source": {
						        "type": "vector",
						        "tiles": [
						            "https://tiles.vindrtech.com/tiles/eistviltcrpzeacjtujf/{z}/{x}/{y}"
						        ]
						    },
						    "layer": {
						        "id": "lv-atama-eistviltcrpzeacjtujf-layer",
						        "type": "fill",
						        "source": "lv-atama-eistviltcrpzeacjtujf-source",
						        "source-layer": "eistviltcrpzeacjtujf",
						        "layout": {},
						        'paint': {
									'fill-opacity': 0.6,
									'fill-color': [
													  "match",
													  ["get", "Risks"],
													  ['Ļoti augts risks / Very high risk'],
													  "#fa3838",
													  ['Vidēji augsts risks'],
													  "#faf138",
													  "#000000"
													],
								}
						    }
						},
						{
						    "id": "lv-atama-qwhrxqivvpbjtxaqehaj-source",
						    "name": "Putni_augsts_risks",
						    "defaultChecked": false,
						    "source": {
						        "type": "vector",
						        "tiles": [
						            "https://tiles.vindrtech.com/tiles/qwhrxqivvpbjtxaqehaj/{z}/{x}/{y}"
						        ]
						    },
						    "layer": {
						        "id": "lv-atama-qwhrxqivvpbjtxaqehaj-layer",
						        "type": "fill",
						        "source": "lv-atama-qwhrxqivvpbjtxaqehaj-source",
						        "source-layer": "qwhrxqivvpbjtxaqehaj",
						        "layout": {},
						        'paint': {
									'fill-opacity': 0.6,
									'fill-color': [
													  "match",
													  ["get", "Risks"],
													  ['Ļoti augts risks / Very high risk'],
													  "#fa3838",
													  ['Vidēji augsts risks'],
													  "#faf138",
													  "#000000"
													],
								}
						    }
						},
						{
						    "id": "lv-atama-diohwalfgkswfqwvhqbm-source",
						    "name": "Putni_videjs_risks",
						    "defaultChecked": false,
						    "source": {
						        "type": "vector",
						        "tiles": [
						            "https://tiles.vindrtech.com/tiles/diohwalfgkswfqwvhqbm/{z}/{x}/{y}"
						        ]
						    },
						    "layer": {
						        "id": "lv-atama-diohwalfgkswfqwvhqbm-layer",
						        "type": "fill",
						        "source": "lv-atama-diohwalfgkswfqwvhqbm-source",
						        "source-layer": "diohwalfgkswfqwvhqbm",
						        "layout": {},
						        'paint': {
									'fill-opacity': 0.6,
									'fill-color': [
													  "match",
													  ["get", "Risks"],
													  ['Ļoti augts risks / Very high risk'],
													  "#fa3838",
													  ['Vidēji augsts risks'],
													  "#faf138",
													  "#000000"
													],
								}
						    }
						},
						{
						    "id": "lv-atama-viahckyibfrycfnxsqae-source",
						    "name": "Putnu_izpetes_buferzona_2km",
						    "defaultChecked": false,
						    "source": {
						        "type": "vector",
						        "tiles": [
						            "https://tiles.vindrtech.com/tiles/viahckyibfrycfnxsqae/{z}/{x}/{y}"
						        ]
						    },
						    "layer": {
						        "id": "lv-atama-viahckyibfrycfnxsqae-layer",
						        "type": "fill",
						        "source": "lv-atama-viahckyibfrycfnxsqae-source",
						        "source-layer": "viahckyibfrycfnxsqae",
						        "layout": {},
						        'paint': {
									'fill-opacity': 0.6,
									'fill-color': [
													  "match",
													  ["get", "Risks"],
													  ['Ļoti augts risks / Very high risk'],
													  "#fa3838",
													  ['Vidēji augsts risks'],
													  "#faf138",
													  "#000000"
													],
								}
						    }
						},
						{
						    "id": "lv-atama-jpagobyjdlfymlpqecvc-source",
						    "name": "Siksparni_buferzonas",
						    "defaultChecked": false,
						    "source": {
						        "type": "vector",
						        "tiles": [
						            "https://tiles.vindrtech.com/tiles/jpagobyjdlfymlpqecvc/{z}/{x}/{y}"
						        ]
						    },
						    "layer": {
						        "id": "lv-atama-jpagobyjdlfymlpqecvc-layer",
						        "type": "fill",
						        "source": "lv-atama-jpagobyjdlfymlpqecvc-source",
						        "source-layer": "jpagobyjdlfymlpqecvc",
						        "layout": {},
						        'paint': {
									'fill-opacity': 0.6,
									'fill-color': [
													  "match",
													  ["get", "Risks"],
													  ['Ļoti augts risks / Very high risk'],
													  "#fa3838",
													  ['Vidēji augsts risks'],
													  "#faf138",
													  "#000000"
													],
								}
						    }
						},
						{
						    "id": "lv-atama-eliwlcfksjqbahnzcwji-source",
						    "name": "Zemes_vienibas",
						    "defaultChecked": false,
						    "source": {
						        "type": "vector",
						        "tiles": [
						            "https://tiles.vindrtech.com/tiles/eliwlcfksjqbahnzcwji/{z}/{x}/{y}"
						        ]
						    },
						    "layer": {
						        "id": "lv-atama-eliwlcfksjqbahnzcwji-layer",
						        "type": "fill",
						        "source": "lv-atama-eliwlcfksjqbahnzcwji-source",
						        "source-layer": "eliwlcfksjqbahnzcwji",
						        "layout": {},
						        'paint': {
									'fill-opacity': 0.6,
									'fill-color': [
													  "match",
													  ["get", "Risks"],
													  ['Ļoti augts risks / Very high risk'],
													  "#fa3838",
													  ['Vidēji augsts risks'],
													  "#faf138",
													  "#000000"
													],
								}
						    }
						},
				]
		},
		{
			name: "Amata Velmeri",
			layers: [	
					{
					        "id": "lv-atama-fjtracdqoeeutropwfsf-source",
					        "name": "Dizkoki",
					        "defaultChecked": false,
					        "source": {
					            "type": "vector",
					            "tiles": [
					                "https://tiles.vindrtech.com/tiles/fjtracdqoeeutropwfsf/{z}/{x}/{y}"
					            ]
					        },
					        "layer": {
					            "id": "lv-atama-fjtracdqoeeutropwfsf-layer",
					            "type": "circle",
					            "source": "lv-atama-fjtracdqoeeutropwfsf-source",
					            "source-layer": "fjtracdqoeeutropwfsf",
					            "layout": {},
					            "paint": {
					                "circle-color": "#000000",
					                "circle-radius": 5
					            }
					        }
					    },
					    {
					        "id": "lv-atama-liesnygzvcxmnpmouyxm-source",
					        "name": "Ipasi_aizsargajamas_sugas",
					        "defaultChecked": false,
					        "source": {
					            "type": "vector",
					            "tiles": [
					                "https://tiles.vindrtech.com/tiles/liesnygzvcxmnpmouyxm/{z}/{x}/{y}"
					            ]
					        },
					        "layer": {
					            "id": "lv-atama-liesnygzvcxmnpmouyxm-layer",
					            "type": "circle",
					            "source": "lv-atama-liesnygzvcxmnpmouyxm-source",
					            "source-layer": "liesnygzvcxmnpmouyxm",
					            "layout": {},
					            "paint": {
					                "circle-color": "#000000",
					                "circle-radius": 5
					            }
					        }
					    },
					    {
					        "id": "lv-atama-xavfoupujvdbhdtdpqei-source",
					        "name": "Kulturas_piemineklu_objekti",
					        "defaultChecked": false,
					        "source": {
					            "type": "vector",
					            "tiles": [
					                "https://tiles.vindrtech.com/tiles/xavfoupujvdbhdtdpqei/{z}/{x}/{y}"
					            ]
					        },
					        "layer": {
					            "id": "lv-atama-xavfoupujvdbhdtdpqei-layer",
					            "type": "circle",
					            "source": "lv-atama-xavfoupujvdbhdtdpqei-source",
					            "source-layer": "xavfoupujvdbhdtdpqei",
					            "layout": {},
					            "paint": {
					                "circle-color": "#000000",
					                "circle-radius": 5
					            }
					        }
					    },
					    {
					        "id": "lv-atama-azswpncytqoqfznvubfh-source",
					        "name": "Ligzdas",
					        "defaultChecked": false,
					        "source": {
					            "type": "vector",
					            "tiles": [
					                "https://tiles.vindrtech.com/tiles/azswpncytqoqfznvubfh/{z}/{x}/{y}"
					            ]
					        },
					        "layer": {
					            "id": "lv-atama-azswpncytqoqfznvubfh-layer",
					            "type": "circle",
					            "source": "lv-atama-azswpncytqoqfznvubfh-source",
					            "source-layer": "azswpncytqoqfznvubfh",
					            "layout": {},
					            "paint": {
					                "circle-color": "#000000",
					                "circle-radius": 5
					            }
					        }
					    },
					    {
					        "id": "lv-atama-tsakkqamtfgkitvwoozh-source",
					        "name": "Veja_turbinu_izvertejums",
					        "defaultChecked": false,
					        "source": {
					            "type": "vector",
					            "tiles": [
					                "https://tiles.vindrtech.com/tiles/tsakkqamtfgkitvwoozh/{z}/{x}/{y}"
					            ]
					        },
					        "layer": {
					            "id": "lv-atama-tsakkqamtfgkitvwoozh-layer",
					            "type": "circle",
					            "source": "lv-atama-tsakkqamtfgkitvwoozh-source",
					            "source-layer": "tsakkqamtfgkitvwoozh",
					            "layout": {},
					            "paint": {
					                "circle-color": "#000000",
					                "circle-radius": 5
					            }
					        }
					    },
					    {
					        "id": "lv-atama-edajzjckorvhrbnxqrhy-source",
					        "name": "Putnu_udensteces_buferzonas",
					        "defaultChecked": false,
					        "source": {
					            "type": "vector",
					            "tiles": [
					                "https://tiles.vindrtech.com/tiles/edajzjckorvhrbnxqrhy/{z}/{x}/{y}"
					            ]
					        },
					        "layer": {
					            "id": "lv-atama-edajzjckorvhrbnxqrhy-layer",
					            "type": "fill",
					            "source": "lv-atama-edajzjckorvhrbnxqrhy-source",
					            "source-layer": "edajzjckorvhrbnxqrhy",
					            "layout": {},
					            'paint': {
									'fill-opacity': 0.6,
									'fill-color': [
													  "match",
													  ["get", "Risks"],
													  ['Ļoti augsts risks'],
													  "#fa3838",
													  ['Vidēji augsts risks'],
													  "#faf138",
													  "#000000"
													],
								}
					        }
					    },
					    {
					        "id": "lv-atama-klvnixsbkajlydeypeqc-source",
					        "name": "Apdzivoto_vietu_aizsargjoslas_800m",
					        "defaultChecked": false,
					        "source": {
					            "type": "vector",
					            "tiles": [
					                "https://tiles.vindrtech.com/tiles/klvnixsbkajlydeypeqc/{z}/{x}/{y}"
					            ]
					        },
					        "layer": {
					            "id": "lv-atama-klvnixsbkajlydeypeqc-layer",
					            "type": "fill",
					            "source": "lv-atama-klvnixsbkajlydeypeqc-source",
					            "source-layer": "klvnixsbkajlydeypeqc",
					            "layout": {},
					            'paint': {
									'fill-opacity': 0.6,
									'fill-color': [
													  "match",
													  ["get", "Risks"],
													  ['Ļoti augsts risks'],
													  "#fa3838",
													  ['Vidēji augsts risks'],
													  "#faf138",
													  "#000000"
													],
								}
					        }
					    },
					    {
					        "id": "lv-atama-fpzepzkttzunsqvcovbv-source",
					        "name": "Celu_infrasrukturas_buferzonas",
					        "defaultChecked": false,
					        "source": {
					            "type": "vector",
					            "tiles": [
					                "https://tiles.vindrtech.com/tiles/fpzepzkttzunsqvcovbv/{z}/{x}/{y}"
					            ]
					        },
					        "layer": {
					            "id": "lv-atama-fpzepzkttzunsqvcovbv-layer",
					            "type": "fill",
					            "source": "lv-atama-fpzepzkttzunsqvcovbv-source",
					            "source-layer": "fpzepzkttzunsqvcovbv",
					            "layout": {},
					            'paint': {
									'fill-opacity': 0.6,
									'fill-color': [
													  "match",
													  ["get", "Risks"],
													  ['Ļoti augsts risks'],
													  "#fa3838",
													  ['Vidēji augsts risks'],
													  "#faf138",
													  "#000000"
													],
								}
					        }
					    },
					    {
					        "id": "lv-atama-lcimaswoilrfxoudkazb-source",
					        "name": "Kultuvesturisko_objektu_buferzonas",
					        "defaultChecked": false,
					        "source": {
					            "type": "vector",
					            "tiles": [
					                "https://tiles.vindrtech.com/tiles/lcimaswoilrfxoudkazb/{z}/{x}/{y}"
					            ]
					        },
					        "layer": {
					            "id": "lv-atama-lcimaswoilrfxoudkazb-layer",
					            "type": "fill",
					            "source": "lv-atama-lcimaswoilrfxoudkazb-source",
					            "source-layer": "lcimaswoilrfxoudkazb",
					            "layout": {},
					            'paint': {
									'fill-opacity': 0.6,
									'fill-color': [
													  "match",
													  ["get", "Risks"],
													  ['Ļoti augsts risks'],
													  "#fa3838",
													  ['Vidēji augsts risks'],
													  "#faf138",
													  "#000000"
													],
								}
					        }
					    },
					    {
					        "id": "lv-atama-lpewywollzckztcpkrjo-source",
					        "name": "Putnu_ligzdu_buferzonas",
					        "defaultChecked": false,
					        "source": {
					            "type": "vector",
					            "tiles": [
					                "https://tiles.vindrtech.com/tiles/lpewywollzckztcpkrjo/{z}/{x}/{y}"
					            ]
					        },
					        "layer": {
					            "id": "lv-atama-lpewywollzckztcpkrjo-layer",
					            "type": "fill",
					            "source": "lv-atama-lpewywollzckztcpkrjo-source",
					            "source-layer": "lpewywollzckztcpkrjo",
					            "layout": {},
					            'paint': {
									'fill-opacity': 0.6,
									'fill-color': [
													  "match",
													  ["get", "Risks"],
													  ['Ļoti augsts risks'],
													  "#fa3838",
													  ['Vidēji augsts risks'],
													  "#faf138",
													  "#000000"
													],
								}
					        }
					    },
					    {
					        "id": "lv-atama-bkidiprhbidccddyclzp-source",
					        "name": "Buferzonas_no_biotopiem_100m",
					        "defaultChecked": false,
					        "source": {
					            "type": "vector",
					            "tiles": [
					                "https://tiles.vindrtech.com/tiles/bkidiprhbidccddyclzp/{z}/{x}/{y}"
					            ]
					        },
					        "layer": {
					            "id": "lv-atama-bkidiprhbidccddyclzp-layer",
					            "type": "fill",
					            "source": "lv-atama-bkidiprhbidccddyclzp-source",
					            "source-layer": "bkidiprhbidccddyclzp",
					            "layout": {},
					            'paint': {
									'fill-opacity': 0.6,
									'fill-color': [
													  "match",
													  ["get", "Risks"],
													  ['Ļoti augsts risks'],
													  "#fa3838",
													  ['Vidēji augsts risks'],
													  "#faf138",
													  "#000000"
													],
								}
					        }
					    },
					    {
					        "id": "lv-atama-pajdeycdbxrvnjjjkapy-source",
					        "name": "Energetikas_infrastrukturas_buferzonas",
					        "defaultChecked": false,
					        "source": {
					            "type": "vector",
					            "tiles": [
					                "https://tiles.vindrtech.com/tiles/pajdeycdbxrvnjjjkapy/{z}/{x}/{y}"
					            ]
					        },
					        "layer": {
					            "id": "lv-atama-pajdeycdbxrvnjjjkapy-layer",
					            "type": "fill",
					            "source": "lv-atama-pajdeycdbxrvnjjjkapy-source",
					            "source-layer": "pajdeycdbxrvnjjjkapy",
					            "layout": {},
					            'paint': {
									'fill-opacity': 0.6,
									'fill-color': [
													  "match",
													  ["get", "Risks"],
													  ['Ļoti augsts risks'],
													  "#fa3838",
													  ['Vidēji augsts risks'],
													  "#faf138",
													  "#000000"
													],
								}
					        }
					    },
					    {
					        "id": "lv-atama-ianuiimvufxkrvyxcmto-source",
					        "name": "Siksparnu_buferzonas",
					        "defaultChecked": false,
					        "source": {
					            "type": "vector",
					            "tiles": [
					                "https://tiles.vindrtech.com/tiles/ianuiimvufxkrvyxcmto/{z}/{x}/{y}"
					            ]
					        },
					        "layer": {
					            "id": "lv-atama-ianuiimvufxkrvyxcmto-layer",
					            "type": "fill",
					            "source": "lv-atama-ianuiimvufxkrvyxcmto-source",
					            "source-layer": "ianuiimvufxkrvyxcmto",
					            "layout": {},
					            'paint': {
									'fill-opacity': 0.6,
									'fill-color': [
													  "match",
													  ["get", "Riski"],
													  ['Ļoti augsts risks'],
													  "#fa3838",
													  ['Vidēji augsts risks'],
													  "#faf138",
													  "#000000"
													],
								}
					        }
					    },
					    {
					        "id": "lv-atama-onvnosnclkyydaazvqwn-source",
					        "name": "Mikroliegumi",
					        "defaultChecked": false,
					        "source": {
					            "type": "vector",
					            "tiles": [
					                "https://tiles.vindrtech.com/tiles/onvnosnclkyydaazvqwn/{z}/{x}/{y}"
					            ]
					        },
					        "layer": {
					            "id": "lv-atama-onvnosnclkyydaazvqwn-layer",
					            "type": "fill",
					            "source": "lv-atama-onvnosnclkyydaazvqwn-source",
					            "source-layer": "onvnosnclkyydaazvqwn",
					            "layout": {},
					            'paint': {
									'fill-opacity': 0.6,
									'fill-color': [
													  "match",
													  ["get", "Risks"],
													  ['Ļoti augsts risks'],
													  "#fa3838",
													  ['Vidēji augsts risks'],
													  "#faf138",
													  "#000000"
													],
								}
					        }
					    },
					    {
					        "id": "lv-atama-scordeqpjuoxysgbmcjv-source",
					        "name": "NATURA_2000_teritorija",
					        "defaultChecked": false,
					        "source": {
					            "type": "vector",
					            "tiles": [
					                "https://tiles.vindrtech.com/tiles/scordeqpjuoxysgbmcjv/{z}/{x}/{y}"
					            ]
					        },
					        "layer": {
					            "id": "lv-atama-scordeqpjuoxysgbmcjv-layer",
					            "type": "fill",
					            "source": "lv-atama-scordeqpjuoxysgbmcjv-source",
					            "source-layer": "scordeqpjuoxysgbmcjv",
					            "layout": {},
					            'paint': {
									'fill-opacity': 0.6,
									'fill-color': [
													  "match",
													  ["get", "Risks"],
													  ['Ļoti augsts risks'],
													  "#fa3838",
													  ['Vidēji augsts risks'],
													  "#faf138",
													  "#000000"
													],
								}
					        }
					    },
					    {
					        "id": "lv-atama-unaozoarilqlsxxtjgrr-source",
					        "name": "Sikparniem_nozimigas_mezaudzes",
					        "defaultChecked": false,
					        "source": {
					            "type": "vector",
					            "tiles": [
					                "https://tiles.vindrtech.com/tiles/unaozoarilqlsxxtjgrr/{z}/{x}/{y}"
					            ]
					        },
					        "layer": {
					            "id": "lv-atama-unaozoarilqlsxxtjgrr-layer",
					            "type": "fill",
					            "source": "lv-atama-unaozoarilqlsxxtjgrr-source",
					            "source-layer": "unaozoarilqlsxxtjgrr",
					            "layout": {},
					            'paint': {
									'fill-opacity': 0.6,
									'fill-color': [
													  "match",
													  ["get", "Risks"],
													  ['Ļoti augsts risks'],
													  "#fa3838",
													  ['Vidēji augsts risks'],
													  "#faf138",
													  "#000000"
													],
								}
					        }
					    },
					    {
					        "id": "lv-atama-ynsobcihymlubdiqadbp-source",
					        "name": "Biotopu_buferzona",
					        "defaultChecked": false,
					        "source": {
					            "type": "vector",
					            "tiles": [
					                "https://tiles.vindrtech.com/tiles/ynsobcihymlubdiqadbp/{z}/{x}/{y}"
					            ]
					        },
					        "layer": {
					            "id": "lv-atama-ynsobcihymlubdiqadbp-layer",
					            "type": "fill",
					            "source": "lv-atama-ynsobcihymlubdiqadbp-source",
					            "source-layer": "ynsobcihymlubdiqadbp",
					            "layout": {},
					            'paint': {
									'fill-opacity': 0.6,
									'fill-color': [
													  "match",
													  ["get", "Risks"],
													  ['Ļoti augsts risks'],
													  "#fa3838",
													  ['Vidēji augsts risks'],
													  "#faf138",
													  "#000000"
													],
								}
					        }
					    },
					    {
					        "id": "lv-atama-vkztyjqnplrgobbcodpq-source",
					        "name": "Dizkoku_buferzonas",
					        "defaultChecked": false,
					        "source": {
					            "type": "vector",
					            "tiles": [
					                "https://tiles.vindrtech.com/tiles/vkztyjqnplrgobbcodpq/{z}/{x}/{y}"
					            ]
					        },
					        "layer": {
					            "id": "lv-atama-vkztyjqnplrgobbcodpq-layer",
					            "type": "fill",
					            "source": "lv-atama-vkztyjqnplrgobbcodpq-source",
					            "source-layer": "vkztyjqnplrgobbcodpq",
					            "layout": {},
					            'paint': {
									'fill-opacity': 0.6,
									'fill-color': [
													  "match",
													  ["get", "Risks"],
													  ['Ļoti augsts risks'],
													  "#fa3838",
													  ['Vidēji augsts risks'],
													  "#faf138",
													  "#000000"
													],
								}
					        }
					    }
					]
		}
	],
	"Norway" : [
		{
			name: "Restrictions",
			icon: "ri-indeterminate-circle-line",
			defaultOpen:false,
			layers: [ 
				{
					id: "cabins-600m",
					name: "Cabins 600 meter",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.norway-hytter-600m-tiles'
					},
					layer:{
						'id': 'cabins-600m-layer',
						'type': 'fill',
						'source': 'cabins-600m',
						'source-layer': 'norway_buildings_600m',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#889ADD',
							'fill-opacity': 0.9
						}
					}
				},
				{
					id: "houses-600m",
					name: "Houses 600 meter",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.norway-buildings-600m-tiles'
					},
					layer:{
						'id': 'houses-600m-layer',
						'type': 'fill',
						'source': 'houses-600m',
						'source-layer': 'norway_buildings_600m',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#CCCCCC',
							'fill-opacity': 0.9
						}
					}
				},
				{
					id: "houses-1000m",
					name: "Houses 1000 meter",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/no_houses_buffered_1000m/{z}/{x}/{y}"]
					},
					layer:[
						{
							'id': 'no-houses-1000m-layer',
							'type': 'fill',
							'source': 'houses-1000m',
							'source-layer': 'no_houses_buffered_1000m',
							'paint': {
								'fill-color': ['get', 'color'],
								'fill-opacity': 1,
								'fill-outline-color': '#000000'
							}
						}
					]
				},
				{
					id: "municipalities-no-negative",
					name: "Municipality traffic light",
					defaultChecked: false,
					source : {
						type: 'raster',
						'tiles': [ 
							'https://vindrtech.com/mapproxy/service?layer=no_municipality_traffic_light&style=&tilematrixset=webmercator&Service=WMTS&Request=GetTile&Version=1.0.0&Format=png&TileMatrix={z}&TileCol={x}&TileRow={y}'
						],
						tileSize: 256
					},
					layer:{
						id: "municipalities-no-negative-layer",
						type: "raster",
						source: "municipalities-no-negative",
						paint: {}
					}
				},
				{
					id: "competitors",
					name: "Competitors projects",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/competitors/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'competitors-layer',
						'type': 'circle',
						'source': 'competitors',
						'source-layer': 'competitors',
						'layout': {
						
						},
						'paint': {
							'circle-color': '#FF0000',
							'circle-radius': 10
						}
					}
				},
				
			]
		},
		{
			name: "Wind",
			icon: "ri-windy-line",
			defaultOpen:false,
			layers: [ 
				{
					id: "wind-no",
					name: "Wind data (100m)",
					defaultChecked: false,
					source : {
						type: 'raster',
						'tiles': [ 
							'https://vindrtech.com/mapproxy/service?layer=wind_map&style=&tilematrixset=webmercator&Service=WMTS&Request=GetTile&Version=1.0.0&Format=png&TileMatrix={z}&TileCol={x}&TileRow={y}'
						],
						tileSize: 256
					},
					layer:{
						id: "wind-no-layer",
						type: "raster",
						source: "wind-no",
						paint: {}
					},
					legend:'https://siteplanner.blob.core.windows.net/uploadimages/wind_legend.png'
				},
				{
					id: "wind-no-150m",
					name: "Wind data (150m)",
					defaultChecked: false,
					source : {
						type: 'raster',
						'tiles': [ 
							'https://vindrtech.com/mapproxy/service?layer=wind_map_150m&style=&tilematrixset=webmercator&Service=WMTS&Request=GetTile&Version=1.0.0&Format=png&TileMatrix={z}&TileCol={x}&TileRow={y}'
						],
						tileSize: 256
					},
					layer:{
						id: "wind-no-150m-layer",
						type: "raster",
						source: "wind-no-150m",
						paint: {}
					},
					legend:'https://siteplanner.blob.core.windows.net/uploadimages/wind_legend.png'
				},
				
			]
		},
		{
			name: "Vindr",
			icon: "ri-home-line",
			defaultOpen:false,
			layers: [ 
				{
					id: "vindr-projects",
					name: "Vindr projects",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles1.vindrtech.com/tiles/get_projects/{z}/{x}/{y}?apikey=Q72LukB1aPKN3lrLuM8TeB5Yiq8nWB"]
					},
					layer:{
						'id': 'vindr-projects-layer',
						'type': 'line',
						'source': 'vindr-projects',
						'source-layer': 'get_projects',
						'layout': {
						
						},
						'paint': {
							'line-color': '#FF0000',
							'line-width': 4
						}
					}
				}
				]
		},

		{
			name: "Infrastructure",
			icon: "ri-signal-tower-line",
			defaultOpen:false,
			layers: [ 
				{
					id: "power-lines",
					name: "Power lines",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.no-grid-tiles'
					},
					layer:{
						'id': 'power-lines-layer',
						'type': 'line',
						'source': 'power-lines',
						'source-layer': 'no-grid-source',
						'layout': {
						
						},
						'paint': {
							'line-color': '#000000',
							'line-width': 2
						}
					}
				},
				{
					id: "substations",
					name: "Substations",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.no-substations-tiles'
					},
					layer:{
						'id': 'substations-layer',
						'type': 'circle',
						'source': 'substations',
						'source-layer': 'no-substations-source',
						'paint': {
							'circle-color': "#000000",
							'circle-radius': 6
						  },
						'layout': {
							
						}
					}
				},
				{
					id: "substations-name",
					name: "Substations name",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.no-substations-tiles'
					},
					layer:{
						'id': 'substations-layer-name',
						'type': 'symbol',
						'source': 'substations-name',
						'source-layer': 'no-substations-source',
						'paint': {
						    "text-color": "#000000"
						  },
						'layout': {
							'text-field': ['get', 'navn'],
							'text-justify': 'auto',
							'text-size': 14,
							'text-offset': [0.5,0],
							'text-anchor': 'left'
						}
					}
				}
				
			]
		},
		{
			name: "Cadastral",
			icon: "ri-octagon-line",
			defaultOpen:false,
			layers: [
				{
					id: "cadastral-no",
					name: "Properties",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.norway-cadastral-units-tiles'
					},
					layer:[
						{
							'id': 'cadastral-no-layer',
							'type': 'line',
							'source': 'cadastral-no',
							'source-layer': 'norway_cadastral_units',
							'layout': {

							},
							'paint': {
								'line-color': '#3477eb',
								'line-width': 1
							},
						},
						{
							'id': 'cadastral-no-label-layer',
							'type': 'symbol',
							'source': 'cadastral-no',
							'source-layer': 'norway_cadastral_units',
							'layout': {

							},
							paint: {
								"text-color": "#3477eb"
							},
							'layout': {
								'text-field': ['get', 'matrikkeln'],

								'text-justify': 'auto',
								'text-size': 12
							}
						}
					]
				},
				{
					id: "cadastral-all",
					name: "Properties with owners",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/landowners_no,cadastral.2/{z}/{x}/{y}"]
					},
					layer:[
						{
							'id': 'cadastral-unknown-fill',
							'type': 'fill',
							'source': 'cadastral-all',
							'source-layer': 'cadastral.2',
							'paint': {
								'fill-color': ['case', ['in', ['get', 'vindrid'], ["literal", []]], "#e5e9f1", '#ffffff'],
								'fill-opacity': ['case', ['in', ['get', 'vindrid'], ["literal", []]], 1, 0]
							}
						},
						{
							'id': 'cadastral-known-fill',
							'type': 'fill',
							'source': 'cadastral-all',
							'source-layer': 'landowners_no',
							'paint': {
								'fill-color': [
							        'case',                             // Start a conditional expression
							        ['has', 'color'],                   // Check if the 'color' property exists
							        ['get', 'color'],                   // If true, use the color from the data
							        '#FFFFFF'                           // Otherwise, use white color
							    ],
								'fill-opacity': 1
							}
						},
						{
							'id': 'cadastral-unknown-fill-line',
							'type': 'line',
							'source': 'cadastral-all',
							'source-layer': 'cadastral.2',
							'paint': {
								'line-color': '#3477eb',
								'line-width': 1
							},
						},
						{
							'id': 'cadastral-unknown-fill-label',
							'type': 'symbol',
							'source': 'cadastral-all',
							'source-layer': 'cadastral.2',
							"layout": {
							    "text-field": ["get", "vindrid"], // Assuming 'name' is the property you want to label with
							    "text-allow-overlap": false,
							    "text-padding": 10,
							    "text-size": [
							      "interpolate",
							      ["linear"],
							      ["zoom"],
							      12, 11, 
							      15, 16  
							    ],
							    "text-max-width": 8,
							    "text-anchor": "center",
							    "text-offset": [0, 0],
							    "text-optional": true,
							    "text-variable-anchor": ["center", "top", "bottom", "left", "right"]
							  },
							  "paint": {
							    "text-color": "#3477eb"
							  },
							  "filter": ["==", "$type", "Polygon"]
						}
					]
				},
				{
					id: "martin",
					name: "testing",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/no_houses_buffered_1000m/{z}/{x}/{y}"]
					},
					layer:[
						{
							'id': 'no_houses_buffered_1000m',
							'type': 'fill',
							'source': 'martin',
							'source-layer': 'no_houses_buffered_1000m'
						},
						
					]
				}
				
				
				
				
				
				// Vindkart - tileset
				// Cadastral data - tileset
				// Buildings - tileset
			]
		},
		
		{
			name: "Zoning plans",
			icon: "ri-map-2-line",
			layers: [
				{
					id: "zoning-plans",
					name: "Zoning plans",
					defaultChecked: false,
					source : {
						type: 'raster',
						tiles: [
							"https://wms.geonorge.no/skwms1/wms.reguleringsplaner?bbox={bbox-epsg-3857}&service=WMS&request=GetMap&layers=Vertikalniva2&styles=&format=image%2Fpng&transparent=true&version=1.1.1&url=https%3A%2F%2Fnve.geodataonline.no%2Farcgis%2Fservices%2FNettanlegg2%2FMapServer%2FWmsServer%3F&name=Nettanlegg&width=256&height=256&srs=EPSG%3A3857",
						],
						tileSize: 256
					},
					layer:{
						id: "zoning-plans-layer",
						type: "raster",
						source: "zoning-plans",
						paint: {}
					}
				},
				{
					id: "municipal-master-plans",
					name: "Municipal master plans",
					defaultChecked: false,
					source : {
						type: 'raster',
						tiles: [
							"https://wms.geonorge.no/skwms1/wms.kommuneplaner?bbox={bbox-epsg-3857}&service=WMS&request=GetMap&layers=Kommuneplan&styles=&format=image%2Fpng&transparent=true&version=1.1.1&url=https%3A%2F%2Fnve.geodataonline.no%2Farcgis%2Fservices%2FNettanlegg2%2FMapServer%2FWmsServer%3F&name=Nettanlegg&width=256&height=256&srs=EPSG%3A3857",
						],
						tileSize: 256
					},
					layer:{
						id: "municipal-master-plans-layer",
						type: "raster",
						source: "municipal-master-plans",
						paint: {}
					}
				},
				// Kommune status - wms
				/*{
					id: "municipal-status-windpower",
					name: "Municipal status wind",
					defaultChecked: false,
					source : {
						type: 'raster',
						tiles: [
							"https://vindrtech.com/mapserver?map=/mapserver/test.map?bbox={bbox-epsg-3857}&service=WMS&request=GetMap&layers=municipalities_no&styles=&format=image%2Fpng&transparent=true&version=1.1.1&url=https%3A%2F%2Fnve.geodataonline.no%2Farcgis%2Fservices%2FNettanlegg2%2FMapServer%2FWmsServer%3F&name=Nettanlegg&width=256&height=256&srs=EPSG%3A3857",
						],
						tileSize: 256
					},
					layer:{
						id: "municipal-status-windpower-layer",
						type: "raster",
						source: "municipal-status-windpower",
						paint: {}
					}
				},*/
				// Kommunegrenser - tileset
				

			]
		},
		{
			name: "Nature",
			icon: "ri-tree-line",
			defaultOpen:false,
			layers: [
				{
					id: "skogbruksplan",
					name: "Skogbruksplan",
					defaultChecked: false,
					source : {
						type: 'raster',
						tiles: [
							"https://wms.nibio.no/cgi-bin/skogbruksplan?language=nor&SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&BBOX={bbox-epsg-3857}&CRS=EPSG:3857&WIDTH=1106&HEIGHT=1199&LAYERS=aldersklasser_eldste_skogen&STYLES=&FORMAT=image/png&DPI=72&MAP_RESOLUTION=72&FORMAT_OPTIONS=dpi:72&TRANSPARENT=TRUE",
						],
						tileSize: 256
					},
					layer:{
						id: "skogbruksplan-layer",
						type: "raster",
						source: "skogbruksplan",
						paint: {}
					}
				},
				{
					id: "bestandsalder",
					name: "SR16 Bestandsalder",
					defaultChecked: false,
					source : {
						type: 'raster',
						tiles: [
							"https://wms.nibio.no/cgi-bin/sr16_beta?language=nor&SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&BBOX={bbox-epsg-3857}&CRS=EPSG:3857&WIDTH=1106&HEIGHT=1199&LAYERS=SRRBESTANDSALDER&STYLES=&FORMAT=image/png&DPI=72&MAP_RESOLUTION=72&FORMAT_OPTIONS=dpi:72&TRANSPARENT=TRUE",
						],
						tileSize: 256
					},
					layer:{
						id: "bestandsalder-layer",
						type: "raster",
						source: "bestandsalder",
						paint: {}
					}
				},
				{
					id: "pristine-nature",
					name: "Pristine nature",
					defaultChecked: false,
					source : {
						type: 'raster',
						tiles: [
							"https://kart.miljodirektoratet.no/geoserver/inngrepsfrinatur/ows?bbox={bbox-epsg-3857}&service=WMS&request=GetMap&layers=status&styles=&format=image%2Fpng&transparent=true&version=1.1.1&url=https%3A%2F%2Fnve.geodataonline.no%2Farcgis%2Fservices%2FNettanlegg2%2FMapServer%2FWmsServer%3F&name=Nettanlegg&width=256&height=256&srs=EPSG%3A3857",
						],
						tileSize: 256
					},
					layer:{
						id: "pristine-nature-layer",
						type: "raster",
						source: "pristine-nature",
						paint: {}
					}
				},
				{
					id: "naturskog",
					name: "Naturskog",
					defaultChecked: false,
					source : {
						type: 'raster',
						tiles: [
							"https://image001.miljodirektoratet.no/arcgis/services/naturskog/naturskog_v1/MapServer/WMSServer?bbox={bbox-epsg-3857}&service=WMS&request=GetMap&layers=skog_etablert_foer_1940_ikke_flatehogd&styles=&format=image%2Fpng&transparent=true&version=1.1.1&width=256&height=256&srs=EPSG%3A3857",
						],
						tileSize: 256
					},
					layer:{
						id: "naturskog-layer",
						type: "raster",
						source: "naturskog",
						paint: {}
					}
				},
				{
					id: "naturskog-closeness",
					name: "Naturskognærhet",
					defaultChecked: false,
					source : {
						type: 'raster',
						tiles: [
							"https://image001.miljodirektoratet.no/arcgis/services/naturskog/naturskog_v1/MapServer/WMSServer?bbox={bbox-epsg-3857}&service=WMS&request=GetMap&layers=naturskogsnaerhet&styles=&format=image%2Fpng&transparent=true&version=1.1.1&width=256&height=256&srs=EPSG%3A3857",
						],
						tileSize: 256
					},
					layer:{
						id: "naturskog-closeness-layer",
						type: "raster",
						source: "naturskog-closeness",
						paint: {}
					}
				},
				{
					id: "naturskog-probability",
					name: "Naturskogsannsynglighet",
					defaultChecked: false,
					source : {
						type: 'raster',
						tiles: [
							"https://image001.miljodirektoratet.no/arcgis/services/naturskog/naturskog_v1/MapServer/WMSServer?bbox={bbox-epsg-3857}&service=WMS&request=GetMap&layers=naturskogssannsynlighet&styles=&format=image%2Fpng&transparent=true&version=1.1.1&width=256&height=256&srs=EPSG%3A3857",
						],
						tileSize: 256
					},
					layer:{
						id: "naturskog-probability-layer",
						type: "raster",
						source: "naturskog-probability",
						paint: {}
					}
				},
				{
					id: "nature-reserves-norway",
					name: "Nature reserves",
					defaultChecked: false,
					source : {
						type: 'raster',
						tiles: [
							"https://kart.miljodirektoratet.no/arcgis/services/vern_hovedtyper/mapserver/WMSServer?bbox={bbox-epsg-3857}&service=WMS&request=GetMap&layers=naturvern_klasser_omrade&styles=&format=image%2Fpng&transparent=true&version=1.1.1&url=https%3A%2F%2Fnve.geodataonline.no%2Farcgis%2Fservices%2FNettanlegg2%2FMapServer%2FWmsServer%3F&name=Nettanlegg&width=256&height=256&srs=EPSG%3A3857",
						],
						tileSize: 256
					},
					layer:{
						id: "nature-reserves-norway-layer",
						type: "raster",
						source: "nature-reserves-norway",
						paint: {}
					}
				},
				{
					id: "outdoor-recreation",
					name: "Outdoor recreation",
					defaultChecked: false,
					source : {
						type: 'raster',
						tiles: [
							"https://kart.miljodirektoratet.no/arcgis/services/friluftsliv_kartlagt/mapserver/WMSServer?bbox={bbox-epsg-3857}&service=WMS&request=GetMap&layers=friluftsliv_kartlagt_verdi&styles=&format=image%2Fpng&transparent=true&version=1.1.1&url=https%3A%2F%2Fnve.geodataonline.no%2Farcgis%2Fservices%2FNettanlegg2%2FMapServer%2FWmsServer%3F&name=Nettanlegg&width=256&height=256&srs=EPSG%3A3857",
						],
						tileSize: 256
					},
					layer:{
						id: "outdoor-recreation-layer",
						type: "raster",
						source: "outdoor-recreation",
						paint: {}
					}
				},

			]
		}
	],
	"Estonia" : [
		{
			name: "Infrastructure",
			icon: "ri-signal-tower-line",
			defaultOpen:false,
			layers: [
				{
					id: "grid-ee-300",
					name: "Power lines 330kV",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.estonia-grid-tiles'
					},
					layer:{
						'id': 'grid-ee-300-layer',
						'type': 'line',
						'source': 'grid-ee-300',
						'source-layer': 'estonia_grid',
						'layout': {
						
						},
						filter: ['==', 'nimipinge', 330],
						'paint': {
							'line-color': '#000000',
							'line-width': 6,
						}
					}
				},
				{
					id: "grid-ee-110",
					name: "Power lines 110kV",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.estonia-grid-tiles'
					},
					layer:{
						'id': 'grid-ee-110-layer',
						'type': 'line',
						'source': 'grid-ee-110',
						'source-layer': 'estonia_grid',
						'layout': {
						
						},
						filter: ['==', 'nimipinge', 110],
						'paint': {
							'line-color': '#000000',
							'line-width': 4,
						}
					}
				},
				{
					id: "grid-minor-ee",
					name: "Power lines <= 35kV",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.estonia-grid-minor-tiles'
					},
					layer:{
						'id': 'grid-minor-ee-layer',
						'type': 'line',
						'source': 'grid-minor-ee',
						'source-layer': 'estonia_grid_minor',
						'layout': {
						
						},
						'paint': {
							'line-color': '#000000',
							'line-width': 2,
						}
					}
				},
				{
					id: "residential-buildings-ee",
					name: "Residential buildings",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_residential_buildings/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'residential-buildings-ee-layer',
						'type': 'fill',
						'source': 'residential-buildings-ee',
						'source-layer': 'ee_residential_buildings',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#0000FF',
							'fill-opacity': 1
						}
					}
				},
				{
					id: "buildings-ee",
					name: "Buildings",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.estonia-buildings-tiles'
					},
					layer:{
						'id': 'buildings-ee-layer',
						'type': 'fill',
						'source': 'buildings-ee',
						'source-layer': 'buildings-estonia-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#000000',
						}
					}
				},
				{
					id: "residential-buildings-ee-buffered-1000m",
					name: "Residential buildings buffer 1000m",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_residential_buildings_buffered_1000m/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'residential-buildings-ee-buffered-1000m-layer',
						'type': 'fill',
						'source': 'residential-buildings-ee-buffered-1000m',
						'source-layer': 'ee_residential_buildings_buffered_1000m',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#000000',
							'fill-opacity': 0.6
						}
					}
				},
				{
					id: "residential-buildings-ee-buffered-1200m",
					name: "Residential buildings buffer 1200m",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_residential_buildings_buffered_1200m/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'residential-buildings-ee-buffered-1200m-layer',
						'type': 'fill',
						'source': 'residential-buildings-ee-buffered-1200m',
						'source-layer': 'ee_residential_buildings_buffered_1200m',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#000000',
							'fill-opacity': 0.6
						}
					}
				},
				{
					id: "residential-buildings-ee-buffered-1500m",
					name: "Residential buildings buffer 1500m",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_residential_buildings_buffered_1500m/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'residential-buildings-ee-buffered-1500m-layer',
						'type': 'fill',
						'source': 'residential-buildings-ee-buffered-1500m',
						'source-layer': 'ee_residential_buildings_buffered_1500m',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#000000',
							'fill-opacity': 0.6
						}
					}
				},
				{
					id: "residential-buildings-ee-buffered-1700m",
					name: "Residential buildings buffer 1700m",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_residential_buildings_buffered_1700m/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'residential-buildings-ee-buffered-1700m-layer',
						'type': 'fill',
						'source': 'residential-buildings-ee-buffered-1700m',
						'source-layer': 'ee_residential_buildings_buffered_1700m',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#000000',
							'fill-opacity': 0.6
						}
					}
				},
				{
					id: "roads-ee",
					name: "Roads minor",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.estonia-roads-tiles'
					},
					layer:{
						'id': 'roads-ee-layer',
						'type': 'line',
						'source': 'roads-ee',
						'source-layer': 'road-estonia-source',
						'layout': {
						
						},
						'paint': {
							'line-color': "hsl(0, 0%, 49%)",
							'line-width': 2
						},
						filter: ['in', 'tyyp', 40, 45, 50, 60, 70, 80],
					}
				},
				{
					id: "roads-major-ee",
					name: "Roads major",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.estonia-roads-tiles'
					},
					layer:{
						'id': 'roads-major-ee-layer',
						'type': 'line',
						'source': 'roads-major-ee',
						'source-layer': 'road-estonia-source',
						'layout': {
						
						},
						'paint': {
							'line-color': [
							  "match",
							  ["get", "tyyp"],
							  [30],
							  "hsl(60, 93%, 61%)",
							  [20, 10],
							  "hsl(37, 98%, 54%)",
							  "hsl(0, 0%, 49%)"
							],
							'line-width': [
							  "match",
							  ["get", "tyyp"],
							  [10],
							  7,
							  [30],
							  4,
							  3
							]
						},
						filter: ['in', 'tyyp', 30, 20, 10],
					}
				}
			]
		},
		{
			name: "Cadastral",
			icon: "ri-octagon-line",
			defaultOpen:false,
			layers: [
				{
					id: "cadastral-ee",
					name: "Cadastral units",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles1.vindrtech.com/tiles/cadastral/{z}/{x}/{y}?apikey=Q72LukB1aPKN3lrLuM8TeB5Yiq8nWB"]
					},
					layer:{
						'id': 'cadastral-ee-layer',
						'type': 'line',
						'source': 'cadastral-ee',
						'source-layer': 'cadastral',
						'layout': {
						
						},
						'paint': {
							'line-color': '#964B00',
							'line-width': 1,
							'line-opacity': 0.6
						}
					}
				},
				{
					id: "cadastral-ee-label",
					name: "Cadastral id (tunnus)",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles1.vindrtech.com/tiles/cadastral/{z}/{x}/{y}?apikey=Q72LukB1aPKN3lrLuM8TeB5Yiq8nWB"]
					},
					layer:{
						'id': 'cadastral-ee-label-layer',
						'type': 'symbol',
						'source': 'cadastral-ee-label',
						'source-layer': 'cadastral',
						'layout': {
						
						},
						paint: {
						    "text-color": "#964B00"
						  },
						'layout': {
							'text-field': ['get', 'tunnus'],
							
							'text-justify': 'auto',
							'text-size': 12
						}
					}
				},
				{
					id: "cadastral-ee-name-label",
					name: "Cadastral name",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles1.vindrtech.com/tiles/cadastral/{z}/{x}/{y}?apikey=Q72LukB1aPKN3lrLuM8TeB5Yiq8nWB"]
					},
					layer:{
						'id': 'cadastral-ee-name-label-layer',
						'type': 'symbol',
						'source': 'cadastral-ee-name-label',
						'source-layer': 'cadastral',
						'layout': {
						
						},
						paint: {
						    "text-color": "#964B00"
						  },
						'layout': {
							'text-field': ['get', 'l_aadress'],
							
							'text-justify': 'auto',
							'text-size': 12
						}
					}
				},
				{
					id: "cadastral-all",
					name: "Properties with owners",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/landowners_ee,cadastral/{z}/{x}/{y}"]
					},
					layer:[
						{
							'id': 'cadastral-unknown-fill',
							'type': 'fill',
							'source': 'cadastral-all',
							'source-layer': 'cadastral',
							'paint': {
								'fill-color': ['case', ['in', ['get', 'vindrid'], ["literal", []]], "#e5e9f1", '#ffffff'],
								'fill-opacity': ['case', ['in', ['get', 'vindrid'], ["literal", []]], 1, 0]
							}
						},
						{
							'id': 'cadastral-known-fill',
							'type': 'fill',
							'source': 'cadastral-all',
							'source-layer': 'landowners_ee',
							'paint': {
								'fill-color': [
							        'case',                             // Start a conditional expression
							        ['has', 'color'],                   // Check if the 'color' property exists
							        ['get', 'color'],                   // If true, use the color from the data
							        '#FFFFFF'                           // Otherwise, use white color
							    ],
								'fill-opacity': 1
							}
						},
						{
							'id': 'cadastral-unknown-fill-line',
							'type': 'line',
							'source': 'cadastral-all',
							'source-layer': 'cadastral',
							'paint': {
								'line-color': '#3477eb',
								'line-width': 1
							},
						},
						{
							'id': 'cadastral-unknown-fill-label',
							'type': 'symbol',
							'source': 'cadastral-all',
							'source-layer': 'cadastral',
							"layout": {
							    "text-field": ["get", "vindrid"], // Assuming 'name' is the property you want to label with
							    "text-allow-overlap": false,
							    "text-padding": 10,
							    "text-size": [
							      "interpolate",
							      ["linear"],
							      ["zoom"],
							      12, 11, 
							      15, 16  
							    ],
							    "text-max-width": 8,
							    "text-anchor": "center",
							    "text-offset": [0, 0],
							    "text-optional": true,
							    "text-variable-anchor": ["center", "top", "bottom", "left", "right"]
							  },
							  "paint": {
							    "text-color": "#3477eb"
							  },
							  "filter": ["==", "$type", "Polygon"]
						}
					]
				}
				// Vindkart - tileset
				// Cadastral data - tileset
				// Buildings - tileset
			]
		},
		{
			name: "Wind",
			icon: "ri-windy-line",
			defaultOpen:false,
			layers: [ 
				{
					id: "wind-ee",
					name: "Wind data (100m)",
					defaultChecked: false,
					source : {
						type: 'raster',
						'tiles': [ 
							'https://vindrtech.com/mapproxy/service?layer=wind_map&style=&tilematrixset=webmercator&Service=WMTS&Request=GetTile&Version=1.0.0&Format=png&TileMatrix={z}&TileCol={x}&TileRow={y}'
						],
						tileSize: 256
					},
					layer:{
						id: "wind-ee-layer",
						type: "raster",
						source: "wind-ee",
						paint: {}
					},
					legend:'https://siteplanner.blob.core.windows.net/uploadimages/wind_legend.png'
				},
				{
					id: "wind-ee-150m",
					name: "Wind data (150m)",
					defaultChecked: false,
					source : {
						type: 'raster',
						'tiles': [ 
							'https://vindrtech.com/mapproxy/service?layer=wind_map_150m&style=&tilematrixset=webmercator&Service=WMTS&Request=GetTile&Version=1.0.0&Format=png&TileMatrix={z}&TileCol={x}&TileRow={y}'
						],
						tileSize: 256
					},
					layer:{
						id: "wind-ee-150m-layer",
						type: "raster",
						source: "wind-ee-150m",
						paint: {}
					},
					legend:'https://siteplanner.blob.core.windows.net/uploadimages/wind_legend.png'
				}
				
			]
		},
		{
			name: "Competitors",
			icon: "ri-virus-line",
			layers: [


				

				{
					id: "competitor-adepte-ee",
					name: "Adepte",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_competitors/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'competitor-adepte-ee-layer',
						'type': 'fill',
						'source': 'competitor-adepte-ee',
						'source-layer': 'ee_competitors',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#00a57f',
						},
						filter: ['==', 'name', 'adepte'],
					}
				},
				{
					id: "competitor-sunly-ee",
					name: "Sunly",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_competitors/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'competitor-sunly-ee-layer',
						'type': 'fill',
						'source': 'competitor-sunly-ee',
						'source-layer': 'ee_competitors',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#a50026',
						},
						filter: ['==', 'name', 'sunly'],
					}
				},
				{
					id: "competitor-eleon-ee",
					name: "Eleon",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_competitors/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'competitor-eleon-ee-layer',
						'type': 'fill',
						'source': 'competitor-eleon-ee',
						'source-layer': 'ee_competitors',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#d73027',
						},
						filter: ['==', 'name', 'eleon'],
					}
				},
				{
					id: "competitor-enery",
					name: "Enery",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_competitors/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'competitor-enery-layer',
						'type': 'fill',
						'source': 'competitor-enery',
						'source-layer': 'ee_competitors',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#f46d43',
						},
						filter: ['==', 'name', 'enery'],
					}
				},
				{
					id: "competitor-evecon",
					name: "Evecon",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_competitors/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'competitor-evecon-layer',
						'type': 'fill',
						'source': 'competitor-evecon',
						'source-layer': 'ee_competitors',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#fdae61',
						},
						filter: ['==', 'name', 'evecon'],
					}
				},
				{
					id: "competitor-sustainable-investments",
					name: "Sustainable Investments",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_competitors/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'competitor-sustainable-investments-layer',
						'type': 'fill',
						'source': 'competitor-sustainable-investments',
						'source-layer': 'ee_competitors',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#fee090',
						},
						filter: ['==', 'name', 'sustainable_investments'],
					}
				},
				{
					id: "competitor-utilitas",
					name: "Utilitas",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_competitors/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'competitor-utilitas-layer',
						'type': 'fill',
						'source': 'competitor-utilitas',
						'source-layer': 'ee_competitors',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#ffffbf',
						},
						filter: ['==', 'name', 'utilitas'],
					}
				},
				{
					id: "competitor-enefit-green",
					name: "Enefit Green",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_competitors/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'competitor-enefit-green-layer',
						'type': 'fill',
						'source': 'competitor-enefit-green',
						'source-layer': 'ee_competitors',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#e0f3f8',
						},
						filter: ['==', 'name', 'enefit_green'],
					}
				},
				{
					id: "competitor-eurowind",
					name: "Eurowind",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_competitors/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'competitor-eurowind-layer',
						'type': 'fill',
						'source': 'competitor-eurowind',
						'source-layer': 'ee_competitors',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#4a6a75',
						},
						filter: ['==', 'name', 'eurowind'],
					}
				},
				{
					id: "competitor-kc-energy",
					name: "KC Energy",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_competitors/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'competitor-kc-energy-layer',
						'type': 'fill',
						'source': 'competitor-kc-energy',
						'source-layer': 'ee_competitors',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#74add1',
						},
						filter: ['==', 'name', 'kc_energy'],
					}
				},
				{
					id: "competitor-tmw-green",
					name: "TMV Green",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_competitors/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'competitor-tmw-green-layer',
						'type': 'fill',
						'source': 'competitor-tmw-green',
						'source-layer': 'ee_competitors',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#4575b4',
						},
						filter: ['==', 'name', 'tmv_green'],
					}
				},
				{
					id: "competitor-ignitis-green",
					name: "Ignitis",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_competitors/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'competitor-ignitis-green-layer',
						'type': 'fill',
						'source': 'competitor-ignitis-green',
						'source-layer': 'ee_competitors',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#34858e',
						},
						filter: ['==', 'name', 'ignitis'],
					}
				}
			]
		},
		{
			name: "Landowners",
			icon: "ri-user-line",
			layers: [
				{
					id: "competitor-foreko",
					name: "Foreko",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.ee-competitors-tiles'
					},
					layer:{
						'id': 'competitor-foreko-layer',
						'type': 'fill',
						'source': 'competitor-evecon',
						'source-layer': 'ee-competitors-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#ff0000',
						},
						filter: ['==', 'name', 'Foreko'],
					}
				},
				{
					id: "competitor-vestman-green",
					name: "Vestman",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_competitors/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'competitor-vestman-green-layer',
						'type': 'fill',
						'source': 'competitor-vestman-green',
						'source-layer': 'ee_competitors',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#313695',
						},
						filter: ['==', 'name', 'vestman'],
					}
				}
				
				// Vindkart - tileset
				// Cadastral data - tileset
				// Buildings - tileset
			]
		},
		{
			name: "Administrative boundaries",
			icon: "ri-community-line",
			layers: [
				{
					id: "counties-ee",
					name: "Counties",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.ee-counties-tiles'
					},
					layer:{
						'id': 'counties-ee-layer',
						'type': 'line',
						'source': 'counties-ee',
						'source-layer': 'ee-counties',
						'layout': {
						
						},
						'paint': {
							'line-color': '#000000',
							'line-width': 3
						}
					}
				},
				{
					id: "municipalities-ee",
					name: "Municipalities",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.ee-municipalities-tiles'
					},
					layer:{
						'id': 'municipalities-ee-layer',
						'type': 'line',
						'source': 'municipalities-ee',
						'source-layer': 'ee-municipalities',
						'layout': {
						
						},
						'paint': {
							'line-color': '#000000',
							'line-width': 2
						}
					}
				},
				{
					id: "settlements-ee",
					name: "Settlements",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.ee-settlements-tiles'
					},
					layer:{
						'id': 'settlements-ee-layer',
						'type': 'line',
						'source': 'settlements-ee',
						'source-layer': 'ee-settlements',
						'layout': {
						
						},
						'paint': {
							'line-color': '#000000',
							'line-width': 1
						}
					}
				},
				
				// Vindkart - tileset
				// Cadastral data - tileset
				// Buildings - tileset
			]
		},
		{
			name: "Restrictions",
			icon: "ri-indeterminate-circle-line",
			defaultOpen:false,
			layers: [
				{
					id: "ee-buildings-1000m-buffer",
					name: "1000 m buffer zone from residential and municipal buildings",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.ee-buildings-1000m-buffer-tiles'
					},
					layer:{
						'id': 'ee-buildings-1000m-buffer-layer',
						'type': 'fill',
						'source': 'ee-buildings-1000m-buffer',
						'source-layer': 'ee-buildings-1000m-buffer',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#000000',
							'fill-opacity': 0.6
						}
					}
				},
				{
					id: "ee-main-roads-300m-buffer",
					name: "300 m buffer zone from national roads",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.ee-main-roads-300m-buffer-tiles'
					},
					layer:{
						'id': 'ee-main-roads-300m-buffer-layer',
						'type': 'fill',
						'source': 'ee-main-roads-300m-buffer',
						'source-layer': 'ee-main-roads-300m-buffer',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#000000',
							'fill-opacity': 0.6
						}
					}
				}
			]
		},
		{
			name: "Nature",
			icon: "ri-tree-line",
			defaultOpen:false,
			layers: [
				{
					id: "natura-2000-source",
					name: "Natura 2000",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.natura-2000-tiles'
					},
					layer:{
						'id': 'natura-2000-source-layer',
						'type': 'fill',
						'source': 'natura-2000-source',
						'source-layer': 'natura-2000-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#8fce00'
						}
					}
				}
			]
		},
		{
			name: "Auction",
			layers: [
				{
					id: "hxvyayzrmvkxukcvjodz-source",
					name: "Auction areas",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/hxvyayzrmvkxukcvjodz/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'hxvyayzrmvkxukcvjodz-layer',
						'type': 'fill',
						'source': 'hxvyayzrmvkxukcvjodz-source',
						'source-layer': 'hxvyayzrmvkxukcvjodz',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#ff33e6',
							'fill-opacity': 1
						}
					},
					
				},
			]
		},
		{
			name: "Änglema",
			layers: [
				{
					id: "ee-anglema-zones-source",
					name: "Zone green",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_anglema_zones/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'ee-anglema-zones-layer',
						'type': 'fill',
						'source': 'ee-anglema-zones-source',
						'source-layer': 'ee_anglema_zones',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#28b463',
							'fill-opacity': 1
						},
						filter: ['==', 'color', 'green']
					},
					
				},
				{
					id: "ee-anglema-zones-yellow-source",
					name: "Zone yellow",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_anglema_zones/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'ee-anglema-zones-yellow-layer',
						'type': 'fill',
						'source': 'ee-anglema-zones-yellow-source',
						'source-layer': 'ee_anglema_zones',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#f7dc6f',
							'fill-opacity': 1
						},
						filter: ['==', 'color', 'yellow']
					},
				}
			]
		},
		{
			name: "Parika",
			layers: [
				{
					id: "ee-parika-zones-source",
					name: "Zone green",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/dbczwhvapozxtosthirh/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'ee-parika-zones-layer',
						'type': 'fill',
						'source': 'ee-parika-zones-source',
						'source-layer': 'dbczwhvapozxtosthirh',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#28b463',
							'fill-opacity': 1
						}
					},
					
				},
				{
					id: "ee-parika-zones-yellow-source",
					name: "Zone yellow",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/nwsycpvkrxrlxdqyordy/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'ee-parika-zones-yellow-layer',
						'type': 'fill',
						'source': 'ee-parika-zones-yellow-source',
						'source-layer': 'nwsycpvkrxrlxdqyordy',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#f7dc6f',
							'fill-opacity': 1
						}
					},
				}
			]
		},
		{
			name: "Pärnu",
			layers: [
				{
					id: "ee-parnu-zones-source",
					name: "Zone green",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_parnu_zones/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'ee-parnu-zones-layer',
						'type': 'fill',
						'source': 'ee-parnu-zones-source',
						'source-layer': 'ee_parnu_zones',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#28b463',
							'fill-opacity': 1
						},
						filter: ['==', 'color', 'green']
					},
					
				},
				{
					id: "ee-parnu-zones-yellow-source",
					name: "Zone yellow",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_parnu_zones/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'ee-parnu-zones-yellow-layer',
						'type': 'fill',
						'source': 'ee-parnu-zones-yellow-source',
						'source-layer': 'ee_parnu_zones',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#f7dc6f',
							'fill-opacity': 1
						},
						filter: ['==', 'color', 'yellow']
					},
				}
			]
		},
		{
			name: "Türi (Riigiala)",
			layers: [
				{
					id: "ee-turi-zones-source",
					name: "Zone green",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_turi_zones_1/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'ee-turi-zones-layer',
						'type': 'fill',
						'source': 'ee-turi-zones-source',
						'source-layer': 'ee_turi_zones_1',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#28b463',
							'fill-opacity': 1
						},
						filter: ['==', 'color', 'green']
					},
					
				},
				{
					id: "ee-turi-zones-yellow-source",
					name: "Zone yellow",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/ee_turi_zones_1/{z}/{x}/{y}"]
					},
					layer:{
						'id': 'ee-turi-zones-yellow-layer',
						'type': 'fill',
						'source': 'ee-turi-zones-yellow-source',
						'source-layer': 'ee_turi_zones_1',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#f7dc6f',
							'fill-opacity': 1
						},
						filter: ['==', 'color', 'yellow']
					},
				}
			]
		},

	],
    "Sweden": [
    	{
			name: "Restrictions",
			icon: "ri-indeterminate-circle-line",
			defaultOpen:false,
			layers: [
				{
					id: "houses-1000m",
					name: "Houses 1000 meter",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/se_houses_1000m/{z}/{x}/{y}"]
					},
					layer:[
						{
							'id': 'se-houses-1000m-layer',
							'type': 'fill',
							'source': 'houses-1000m',
							'source-layer': 'se_houses_1000m',
							'paint': {
								'fill-color': '#FF1010',
								'fill-opacity': 0.7
							}
						}
					]
				},
				{
					id: "houses-800m",
					name: "Houses 800 meter",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/se_houses_800m/{z}/{x}/{y}"]
					},
					layer:[
						{
							'id': 'se_houses_800m-layer',
							'type': 'fill',
							'source': 'houses-800m',
							'source-layer': 'se_houses_800m',
							'paint': {
								'fill-color': '#8C145A',
								'fill-opacity': 0.7
							}
						}
					]
				},
				{
					id: "houses-600m",
					name: "Houses 600 meter",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/se_houses_600m/{z}/{x}/{y}"]
					},
					layer:[
						{
							'id': 'se_houses_600m-layer',
							'type': 'fill',
							'source': 'houses-600m',
							'source-layer': 'se_houses_600m',
							'paint': {
								'fill-color': '#1919A4',
								'fill-opacity': 0.7
							}
						}
					]
				},
			]
		},
		{
			name: "Infrastructure",
			icon: "ri-signal-tower-line",
			defaultOpen:false,
			layers: [
				{
					id: "se-residential",
					name: "Residential houses",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/buildings/{z}/{x}/{y}"]
					},
					layer:[
						{
							'id': 'se-residential-layer',
							'type': 'fill',
							'source': 'se-residential',
							'source-layer': 'buildings',
							'paint': {
								'fill-color': '#ff0000',
								'fill-opacity': 0.7
							},
							filter: ['==', 'objekttyp', 'Bostad'],
						}
					]
				},
				{
					id: "se-buildings",
					name: "Buildings",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/buildings/{z}/{x}/{y}"]
					},
					layer:[
						{
							'id': 'se-buildings-layer',
							'type': 'fill',
							'source': 'se-buildings',
							'source-layer': 'buildings',
							'paint': {
								'fill-color': '#000000',
								'fill-opacity': 0.7
							}
						}
					]
				}
			]
		},
    	{
			name: "Cadastral",
			icon: "ri-octagon-line",
			layers: [
				{
					id: "cadastral-units-se",
					name: "Cadastral units",
					defaultChecked: false,
					source : {
						type: 'raster',
						'tiles': [ 
							'https://vindrtech.com/mapproxy/service?layer=sweden_fastighet&style=&tilematrixset=webmercator&Service=WMTS&Request=GetTile&Version=1.0.0&Format=png&TileMatrix={z}&TileCol={x}&TileRow={y}'
						],
						tileSize: 256
					},
					layer:{
						id: "cadastral-units-se-layer",
						type: "raster",
						source: "cadastral-units-se",
						paint: {}
					}
				},
				{
					id: "cadastral-all",
					name: "Properties with owners",
					defaultChecked: false,
					source : {
						type: 'vector',
						tiles: ["https://tiles.vindrtech.com/tiles/landowners_se,cadastral.3/{z}/{x}/{y}"]
					},
					layer:[
						{
							'id': 'cadastral-unknown-fill',
							'type': 'fill',
							'source': 'cadastral-all',
							'source-layer': 'cadastral.3',
							'paint': {
								'fill-color': ['case', ['in', ['get', 'vindrid'], ["literal", []]], "#e5e9f1", '#ffffff'],
								'fill-opacity': ['case', ['in', ['get', 'vindrid'], ["literal", []]], 1, 0]
							}
						},
						{
							'id': 'cadastral-known-fill',
							'type': 'fill',
							'source': 'cadastral-all',
							'source-layer': 'landowners_se',
							'paint': {
								'fill-color': [
							        'case',                             // Start a conditional expression
							        ['has', 'color'],                   // Check if the 'color' property exists
							        ['get', 'color'],                   // If true, use the color from the data
							        '#FFFFFF'                           // Otherwise, use white color
							    ],
								'fill-opacity': 1
							}
						},
						{
							'id': 'cadastral-unknown-fill-line',
							'type': 'line',
							'source': 'cadastral-all',
							'source-layer': 'cadastral.3',
							'paint': {
								'line-color': '#3477eb',
								'line-width': 1
							},
						},
						{
							'id': 'cadastral-unknown-fill-label',
							'type': 'symbol',
							'source': 'cadastral-all',
							'source-layer': 'cadastral.3',
							"layout": {
							    "text-field": ["get", "vindrid"], // Assuming 'name' is the property you want to label with
							    "text-allow-overlap": false,
							    "text-padding": 10,
							    "text-size": [
							      "interpolate",
							      ["linear"],
							      ["zoom"],
							      12, 11, 
							      15, 16  
							    ],
							    "text-max-width": 8,
							    "text-anchor": "center",
							    "text-offset": [0, 0],
							    "text-optional": true,
							    "text-variable-anchor": ["center", "top", "bottom", "left", "right"]
							  },
							  "paint": {
							    "text-color": "#3477eb"
							  },
							  "filter": ["==", "$type", "Polygon"]
						}
					]
				}
			]
		},
		{
			name: "Wind",
			icon: "ri-octagon-line",
			layers: [
				{
					id: "wind-se",
					name: "Wind data (100m)",
					defaultChecked: false,
					source : {
						type: 'raster',
						'tiles': [ 
							'https://vindrtech.com/mapproxy/service?layer=wind_map&style=&tilematrixset=webmercator&Service=WMTS&Request=GetTile&Version=1.0.0&Format=png&TileMatrix={z}&TileCol={x}&TileRow={y}'
						],
						tileSize: 256
					},
					layer:{
						id: "wind-se-layer",
						type: "raster",
						source: "wind-se",
						paint: {}
					}
				},
				{
					id: "wind-se-150m",
					name: "Wind data (150m)",
					defaultChecked: false,
					source : {
						type: 'raster',
						'tiles': [ 
							'https://vindrtech.com/mapproxy/service?layer=wind_map_150m&style=&tilematrixset=webmercator&Service=WMTS&Request=GetTile&Version=1.0.0&Format=png&TileMatrix={z}&TileCol={x}&TileRow={y}'
						],
						tileSize: 256
					},
					layer:{
						id: "wind-se-150m-layer",
						type: "raster",
						source: "wind-se-150m",
						paint: {}
					}
				},
				{
					id: "wind-se-125m",
					name: "Wind data (125m)",
					defaultChecked: false,
					source : {
						type: 'raster',
						'tiles': [ 
							'https://vindrtech.com/mapproxy/service?layer=wind_map_se&style=&tilematrixset=webmercator&Service=WMTS&Request=GetTile&Version=1.0.0&Format=png&TileMatrix={z}&TileCol={x}&TileRow={y}'
						],
						tileSize: 256
					},
					layer:{
						id: "wind-se-125-layer",
						type: "raster",
						source: "wind-se-125m",
						paint: {}
					}
				},
				{
					id: "wind-se-125m-d",
					name: "Wind data (125m D)",
					defaultChecked: false,
					source : {
						type: 'raster',
						'tiles': [ 
							'https://vindrtech.com/mapproxy/service?layer=wind_map_se_d&style=&tilematrixset=webmercator&Service=WMTS&Request=GetTile&Version=1.0.0&Format=png&TileMatrix={z}&TileCol={x}&TileRow={y}'
						],
						tileSize: 256
					},
					layer:{
						id: "wind-se-125m-d-layer",
						type: "raster",
						source: "wind-se-125m-d",
						paint: {}
					}
				},
			]
		},
    	{
			name: "Nature",
			icon: "ri-tree-line",
			defaultOpen:false,
			layers: [
				{
					id: "natura-2000-source",
					name: "Natura 2000",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.natura-2000-tiles'
					},
					layer:{
						'id': 'natura-2000-source-layer',
						'type': 'fill',
						'source': 'natura-2000-source',
						'source-layer': 'natura-2000-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': '#8fce00'
						}
					}
				}
			]
		},
		{
			name: "Other",
			icon: "ri-circle-line",
			defaultOpen:false,
			layers: [
				{
					id: "se-price-areas-source",
					name: "Price regions",
					defaultChecked: false,
					source : {
						type: 'vector',
						url: 'mapbox://espenvindr.se-price-areas-tiles'
					},
					layer:{
						'id': 'se-price-areas-source-layer',
						'type': 'fill',
						'source': 'se-price-areas-source',
						'source-layer': 'se-price-areas-source',
						'layout': {
						
						},
						'paint': {
							'fill-color': [
								'case',
								['==', ['get', 'Namn'], 'SE1'],
								'#edf8fb',
								['==', ['get', 'Namn'], 'SE2'],
								'#b2e2e2',
								['==', ['get', 'Namn'], 'SE3'],
								'#66c2a4',
								'#238b45'
							],
							'fill-opacity': 0.6,
							'fill-outline-color': '#000000',
						}
					}
				}
			]
		}
    ],
    
	"All" : [
		
	],
	"compile" : function(country) {
		
		var output = [];
		if(this[country]){
			output = JSON.parse(JSON.stringify(this[country])); // clone the country layers
			
			this.All.map((section)=>{
				var idx = -1;
				if((idx = output.findIndex((sec)=>sec.name == section.name)) != -1 ){
					output[idx].layers.push(...section.layers);
				}
				else
					output.push(section)
			});
			
		}
		else
			output = this.All;
		this.currentSet = output;
		
		return this;
	},
	"countries" : function(country) {
		
		var copy = {...this};
		var output = [];
		delete copy.compile;
		delete copy.currentSet
		delete copy.countries
		
		var countries = Object.getOwnPropertyNames(copy);
		countries.map((country)=>{
			output.push({
				name: country,
				sections:copy[country]
			});
		})
		
		
		return output;
	},
	"currentSet":[],
}





export { infoLayers };


